/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Favcy Select API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ActivityItem,
  AdminConversationDrillDownResponse,
  AdminConversationsRollupRow,
  AllocateCohortCreditsBody,
  AnnouncementRecipientsResponse,
  AnnouncementSendResult,
  ApproveUpdateItemBody,
  AssignTeamBody,
  AssignTeamToCohort201,
  AuditEntry,
  Cohort,
  CohortAnnouncement,
  CohortAnnouncementDetail,
  CohortCreditBatch,
  CohortCreditReview,
  CohortCreditView,
  CohortDetail,
  CohortImportConfirmation,
  CohortImportInput,
  CohortImportReview,
  CohortTeamMemberEntry,
  CohortWithStats,
  CommitCohortCredits200,
  CommitCohortCreditsBody,
  CommitCohortImport200,
  Company,
  CompanyMicrosite,
  CompanyUpdateHealth,
  CreateAnnouncementBody,
  CreateCohortBody,
  CreateCompanyBody,
  CreateDocumentBody,
  CreateEquityRelationship,
  CreateFounderBody,
  CreateInvestorBody,
  CreateKavyaNoteBody,
  CreateKpiBody,
  CreateMediaBody,
  CreateSourceObject,
  CreateTaskAsk,
  CreateTeamMemberBody,
  CreateUpdateBody,
  CreateUpdateCycle,
  CreateUpdateItem,
  DashboardSummary,
  Document,
  EmailWorkspaceData,
  EquityRelationship,
  Founder,
  FounderApproveItemBody,
  FounderCheckin,
  FounderHome,
  GetAdminCohortCreditsParams,
  GetAdminConversationDrillDownParams,
  GetDashboardSummaryParams,
  GetEmailPersonHistoryParams,
  GetFounderProfilePreviewParams,
  GetInvestorCohortCreditsParams,
  GetMyFoundersParams,
  GetPipelineBreakdownParams,
  GetRecentActivityParams,
  GetUpdateHealthParams,
  GrantInvestorAccessBody,
  HealthStatus,
  Investor,
  InvestorAccess,
  InvestorCohortMembershipList,
  InvestorHome,
  KavyaBriefingNote,
  KpiEntry,
  ListAuditLogParams,
  ListCompaniesParams,
  ListDocumentsParams,
  ListEmailPeopleParams,
  ListEquityRelationshipsParams,
  ListFoundersParams,
  ListInvestorAccessParams,
  ListKpisParams,
  ListMediaParams,
  ListSourcesParams,
  ListTasksParams,
  ListUpdateCyclesParams,
  ListUpdateItemsParams,
  ListUpdatesParams,
  MediaAsset,
  MyFoundersResponse,
  PipelineStage,
  ReleaseCohortCreditsBody,
  RemoveTeamFromCohort200,
  SendOnboardingEmailResponse,
  SourceObject,
  TaskAsk,
  TeamMember,
  TransitionUpdateCycleBody,
  UpdateCohortBody,
  UpdateCompanyBody,
  UpdateCycle,
  UpdateCycleWithItems,
  UpdateFounderBody,
  UpdateInvestorBody,
  UpdateItem,
  UpdateKavyaNoteBody,
  UpdateTaskAsk,
  UpdateTeamMemberBody,
  UpdateUpdateBody,
  WeeklyUpdate,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetEmailWorkspaceUrl = () => {
  return `/api/admin/email`;
};

export const getEmailWorkspace = async (
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getGetEmailWorkspaceUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailWorkspaceQueryKey = () => {
  return [`/api/admin/email`] as const;
};

export const getGetEmailWorkspaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailWorkspace>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEmailWorkspace>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailWorkspaceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailWorkspace>>
  > = ({ signal }) => getEmailWorkspace({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailWorkspace>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailWorkspace>>
>;
export type GetEmailWorkspaceQueryError = ErrorType<unknown>;

export function useGetEmailWorkspace<
  TData = Awaited<ReturnType<typeof getEmailWorkspace>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEmailWorkspace>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailWorkspaceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateEmailDraftUrl = () => {
  return `/api/admin/email/drafts`;
};

export const createEmailDraft = async (
  emailWorkspaceData: EmailWorkspaceData,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getCreateEmailDraftUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(emailWorkspaceData),
  });
};

export const getCreateEmailDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEmailDraft>>,
    TError,
    { data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEmailDraft>>,
  TError,
  { data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  const mutationKey = ["createEmailDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEmailDraft>>,
    { data: BodyType<EmailWorkspaceData> }
  > = (props) => {
    const { data } = props ?? {};

    return createEmailDraft(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEmailDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEmailDraft>>
>;
export type CreateEmailDraftMutationBody = BodyType<EmailWorkspaceData>;
export type CreateEmailDraftMutationError = ErrorType<unknown>;

export const useCreateEmailDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEmailDraft>>,
    TError,
    { data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEmailDraft>>,
  TError,
  { data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  return useMutation(getCreateEmailDraftMutationOptions(options));
};

export const getGetEmailMessageUrl = (id: number) => {
  return `/api/admin/email/messages/${id}`;
};

export const getEmailMessage = async (
  id: number,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getGetEmailMessageUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailMessageQueryKey = (id: number) => {
  return [`/api/admin/email/messages/${id}`] as const;
};

export const getGetEmailMessageQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailMessage>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEmailMessage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailMessageQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailMessage>>> = ({
    signal,
  }) => getEmailMessage(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailMessage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailMessageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailMessage>>
>;
export type GetEmailMessageQueryError = ErrorType<unknown>;

export function useGetEmailMessage<
  TData = Awaited<ReturnType<typeof getEmailMessage>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEmailMessage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailMessageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateEmailDraftUrl = (id: number) => {
  return `/api/admin/email/messages/${id}`;
};

export const updateEmailDraft = async (
  id: number,
  emailWorkspaceData: EmailWorkspaceData,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getUpdateEmailDraftUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(emailWorkspaceData),
  });
};

export const getUpdateEmailDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailDraft>>,
    TError,
    { id: number; data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailDraft>>,
  TError,
  { id: number; data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  const mutationKey = ["updateEmailDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailDraft>>,
    { id: number; data: BodyType<EmailWorkspaceData> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEmailDraft(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailDraft>>
>;
export type UpdateEmailDraftMutationBody = BodyType<EmailWorkspaceData>;
export type UpdateEmailDraftMutationError = ErrorType<unknown>;

export const useUpdateEmailDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailDraft>>,
    TError,
    { id: number; data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailDraft>>,
  TError,
  { id: number; data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  return useMutation(getUpdateEmailDraftMutationOptions(options));
};

export const getActOnEmailMessageUrl = (id: number) => {
  return `/api/admin/email/messages/${id}/action`;
};

export const actOnEmailMessage = async (
  id: number,
  emailWorkspaceData: EmailWorkspaceData,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getActOnEmailMessageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(emailWorkspaceData),
  });
};

export const getActOnEmailMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actOnEmailMessage>>,
    TError,
    { id: number; data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof actOnEmailMessage>>,
  TError,
  { id: number; data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  const mutationKey = ["actOnEmailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof actOnEmailMessage>>,
    { id: number; data: BodyType<EmailWorkspaceData> }
  > = (props) => {
    const { id, data } = props ?? {};

    return actOnEmailMessage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActOnEmailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof actOnEmailMessage>>
>;
export type ActOnEmailMessageMutationBody = BodyType<EmailWorkspaceData>;
export type ActOnEmailMessageMutationError = ErrorType<unknown>;

export const useActOnEmailMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actOnEmailMessage>>,
    TError,
    { id: number; data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof actOnEmailMessage>>,
  TError,
  { id: number; data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  return useMutation(getActOnEmailMessageMutationOptions(options));
};

export const getListEmailPeopleUrl = (params?: ListEmailPeopleParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/email/people?${stringifiedParams}`
    : `/api/admin/email/people`;
};

export const listEmailPeople = async (
  params?: ListEmailPeopleParams,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getListEmailPeopleUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListEmailPeopleQueryKey = (params?: ListEmailPeopleParams) => {
  return [`/api/admin/email/people`, ...(params ? [params] : [])] as const;
};

export const getListEmailPeopleQueryOptions = <
  TData = Awaited<ReturnType<typeof listEmailPeople>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEmailPeopleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEmailPeople>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEmailPeopleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailPeople>>> = ({
    signal,
  }) => listEmailPeople(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEmailPeople>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEmailPeopleQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEmailPeople>>
>;
export type ListEmailPeopleQueryError = ErrorType<unknown>;

export function useListEmailPeople<
  TData = Awaited<ReturnType<typeof listEmailPeople>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEmailPeopleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEmailPeople>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEmailPeopleQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetEmailPersonHistoryUrl = (
  params: GetEmailPersonHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/email/history?${stringifiedParams}`
    : `/api/admin/email/history`;
};

export const getEmailPersonHistory = async (
  params: GetEmailPersonHistoryParams,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getGetEmailPersonHistoryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailPersonHistoryQueryKey = (
  params?: GetEmailPersonHistoryParams,
) => {
  return [`/api/admin/email/history`, ...(params ? [params] : [])] as const;
};

export const getGetEmailPersonHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailPersonHistory>>,
  TError = ErrorType<unknown>,
>(
  params: GetEmailPersonHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEmailPersonHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEmailPersonHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailPersonHistory>>
  > = ({ signal }) =>
    getEmailPersonHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailPersonHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailPersonHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailPersonHistory>>
>;
export type GetEmailPersonHistoryQueryError = ErrorType<unknown>;

export function useGetEmailPersonHistory<
  TData = Awaited<ReturnType<typeof getEmailPersonHistory>>,
  TError = ErrorType<unknown>,
>(
  params: GetEmailPersonHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEmailPersonHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailPersonHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateEmailPreferenceUrl = () => {
  return `/api/admin/email/preferences`;
};

export const updateEmailPreference = async (
  emailWorkspaceData: EmailWorkspaceData,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getUpdateEmailPreferenceUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(emailWorkspaceData),
  });
};

export const getUpdateEmailPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailPreference>>,
    TError,
    { data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailPreference>>,
  TError,
  { data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  const mutationKey = ["updateEmailPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailPreference>>,
    { data: BodyType<EmailWorkspaceData> }
  > = (props) => {
    const { data } = props ?? {};

    return updateEmailPreference(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailPreference>>
>;
export type UpdateEmailPreferenceMutationBody = BodyType<EmailWorkspaceData>;
export type UpdateEmailPreferenceMutationError = ErrorType<unknown>;

export const useUpdateEmailPreference = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailPreference>>,
    TError,
    { data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailPreference>>,
  TError,
  { data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  return useMutation(getUpdateEmailPreferenceMutationOptions(options));
};

export const getUpdateEmailSettingsUrl = () => {
  return `/api/admin/email/settings`;
};

export const updateEmailSettings = async (
  emailWorkspaceData: EmailWorkspaceData,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getUpdateEmailSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(emailWorkspaceData),
  });
};

export const getUpdateEmailSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailSettings>>,
    TError,
    { data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailSettings>>,
  TError,
  { data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  const mutationKey = ["updateEmailSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailSettings>>,
    { data: BodyType<EmailWorkspaceData> }
  > = (props) => {
    const { data } = props ?? {};

    return updateEmailSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailSettings>>
>;
export type UpdateEmailSettingsMutationBody = BodyType<EmailWorkspaceData>;
export type UpdateEmailSettingsMutationError = ErrorType<unknown>;

export const useUpdateEmailSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailSettings>>,
    TError,
    { data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailSettings>>,
  TError,
  { data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  return useMutation(getUpdateEmailSettingsMutationOptions(options));
};

export const getAskEmailAssistantUrl = () => {
  return `/api/admin/email/assistant`;
};

export const askEmailAssistant = async (
  emailWorkspaceData: EmailWorkspaceData,
  options?: RequestInit,
): Promise<EmailWorkspaceData> => {
  return customFetch<EmailWorkspaceData>(getAskEmailAssistantUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(emailWorkspaceData),
  });
};

export const getAskEmailAssistantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof askEmailAssistant>>,
    TError,
    { data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof askEmailAssistant>>,
  TError,
  { data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  const mutationKey = ["askEmailAssistant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof askEmailAssistant>>,
    { data: BodyType<EmailWorkspaceData> }
  > = (props) => {
    const { data } = props ?? {};

    return askEmailAssistant(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AskEmailAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof askEmailAssistant>>
>;
export type AskEmailAssistantMutationBody = BodyType<EmailWorkspaceData>;
export type AskEmailAssistantMutationError = ErrorType<unknown>;

export const useAskEmailAssistant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof askEmailAssistant>>,
    TError,
    { data: BodyType<EmailWorkspaceData> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof askEmailAssistant>>,
  TError,
  { data: BodyType<EmailWorkspaceData> },
  TContext
> => {
  return useMutation(getAskEmailAssistantMutationOptions(options));
};

export const getGetAdminCohortCreditsUrl = (
  params: GetAdminCohortCreditsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/cohort-credits?${stringifiedParams}`
    : `/api/admin/cohort-credits`;
};

export const getAdminCohortCredits = async (
  params: GetAdminCohortCreditsParams,
  options?: RequestInit,
): Promise<CohortCreditView> => {
  return customFetch<CohortCreditView>(getGetAdminCohortCreditsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminCohortCreditsQueryKey = (
  params?: GetAdminCohortCreditsParams,
) => {
  return [`/api/admin/cohort-credits`, ...(params ? [params] : [])] as const;
};

export const getGetAdminCohortCreditsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCohortCredits>>,
  TError = ErrorType<unknown>,
>(
  params: GetAdminCohortCreditsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminCohortCredits>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminCohortCreditsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCohortCredits>>
  > = ({ signal }) =>
    getAdminCohortCredits(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCohortCredits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminCohortCreditsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCohortCredits>>
>;
export type GetAdminCohortCreditsQueryError = ErrorType<unknown>;

export function useGetAdminCohortCredits<
  TData = Awaited<ReturnType<typeof getAdminCohortCredits>>,
  TError = ErrorType<unknown>,
>(
  params: GetAdminCohortCreditsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminCohortCredits>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminCohortCreditsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetInvestorCohortCreditsUrl = (
  params: GetInvestorCohortCreditsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/investor-portal/cohort-credits?${stringifiedParams}`
    : `/api/investor-portal/cohort-credits`;
};

export const getInvestorCohortCredits = async (
  params: GetInvestorCohortCreditsParams,
  options?: RequestInit,
): Promise<CohortCreditView> => {
  return customFetch<CohortCreditView>(getGetInvestorCohortCreditsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetInvestorCohortCreditsQueryKey = (
  params?: GetInvestorCohortCreditsParams,
) => {
  return [
    `/api/investor-portal/cohort-credits`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetInvestorCohortCreditsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvestorCohortCredits>>,
  TError = ErrorType<unknown>,
>(
  params: GetInvestorCohortCreditsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestorCohortCredits>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvestorCohortCreditsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInvestorCohortCredits>>
  > = ({ signal }) =>
    getInvestorCohortCredits(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvestorCohortCredits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvestorCohortCreditsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvestorCohortCredits>>
>;
export type GetInvestorCohortCreditsQueryError = ErrorType<unknown>;

export function useGetInvestorCohortCredits<
  TData = Awaited<ReturnType<typeof getInvestorCohortCredits>>,
  TError = ErrorType<unknown>,
>(
  params: GetInvestorCohortCreditsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestorCohortCredits>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvestorCohortCreditsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPreviewCohortCreditsUrl = () => {
  return `/api/admin/cohort-credits/preview`;
};

export const previewCohortCredits = async (
  cohortCreditBatch: CohortCreditBatch,
  options?: RequestInit,
): Promise<CohortCreditReview> => {
  return customFetch<CohortCreditReview>(getPreviewCohortCreditsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cohortCreditBatch),
  });
};

export const getPreviewCohortCreditsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewCohortCredits>>,
    TError,
    { data: BodyType<CohortCreditBatch> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewCohortCredits>>,
  TError,
  { data: BodyType<CohortCreditBatch> },
  TContext
> => {
  const mutationKey = ["previewCohortCredits"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewCohortCredits>>,
    { data: BodyType<CohortCreditBatch> }
  > = (props) => {
    const { data } = props ?? {};

    return previewCohortCredits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewCohortCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewCohortCredits>>
>;
export type PreviewCohortCreditsMutationBody = BodyType<CohortCreditBatch>;
export type PreviewCohortCreditsMutationError = ErrorType<unknown>;

export const usePreviewCohortCredits = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewCohortCredits>>,
    TError,
    { data: BodyType<CohortCreditBatch> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewCohortCredits>>,
  TError,
  { data: BodyType<CohortCreditBatch> },
  TContext
> => {
  return useMutation(getPreviewCohortCreditsMutationOptions(options));
};

export const getCommitCohortCreditsUrl = () => {
  return `/api/admin/cohort-credits/commit`;
};

export const commitCohortCredits = async (
  commitCohortCreditsBody: CommitCohortCreditsBody,
  options?: RequestInit,
): Promise<CommitCohortCredits200> => {
  return customFetch<CommitCohortCredits200>(getCommitCohortCreditsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(commitCohortCreditsBody),
  });
};

export const getCommitCohortCreditsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commitCohortCredits>>,
    TError,
    { data: BodyType<CommitCohortCreditsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof commitCohortCredits>>,
  TError,
  { data: BodyType<CommitCohortCreditsBody> },
  TContext
> => {
  const mutationKey = ["commitCohortCredits"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof commitCohortCredits>>,
    { data: BodyType<CommitCohortCreditsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return commitCohortCredits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommitCohortCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof commitCohortCredits>>
>;
export type CommitCohortCreditsMutationBody = BodyType<CommitCohortCreditsBody>;
export type CommitCohortCreditsMutationError = ErrorType<void>;

export const useCommitCohortCredits = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commitCohortCredits>>,
    TError,
    { data: BodyType<CommitCohortCreditsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof commitCohortCredits>>,
  TError,
  { data: BodyType<CommitCohortCreditsBody> },
  TContext
> => {
  return useMutation(getCommitCohortCreditsMutationOptions(options));
};

export const getAllocateCohortCreditsUrl = () => {
  return `/api/admin/cohort-credits/allocate`;
};

export const allocateCohortCredits = async (
  allocateCohortCreditsBody: AllocateCohortCreditsBody,
  options?: RequestInit,
): Promise<CohortCreditView> => {
  return customFetch<CohortCreditView>(getAllocateCohortCreditsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(allocateCohortCreditsBody),
  });
};

export const getAllocateCohortCreditsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allocateCohortCredits>>,
    TError,
    { data: BodyType<AllocateCohortCreditsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allocateCohortCredits>>,
  TError,
  { data: BodyType<AllocateCohortCreditsBody> },
  TContext
> => {
  const mutationKey = ["allocateCohortCredits"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allocateCohortCredits>>,
    { data: BodyType<AllocateCohortCreditsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return allocateCohortCredits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllocateCohortCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof allocateCohortCredits>>
>;
export type AllocateCohortCreditsMutationBody =
  BodyType<AllocateCohortCreditsBody>;
export type AllocateCohortCreditsMutationError = ErrorType<void>;

export const useAllocateCohortCredits = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allocateCohortCredits>>,
    TError,
    { data: BodyType<AllocateCohortCreditsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof allocateCohortCredits>>,
  TError,
  { data: BodyType<AllocateCohortCreditsBody> },
  TContext
> => {
  return useMutation(getAllocateCohortCreditsMutationOptions(options));
};

export const getReleaseCohortCreditsUrl = () => {
  return `/api/admin/cohort-credits/release`;
};

export const releaseCohortCredits = async (
  releaseCohortCreditsBody: ReleaseCohortCreditsBody,
  options?: RequestInit,
): Promise<CohortCreditView> => {
  return customFetch<CohortCreditView>(getReleaseCohortCreditsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(releaseCohortCreditsBody),
  });
};

export const getReleaseCohortCreditsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseCohortCredits>>,
    TError,
    { data: BodyType<ReleaseCohortCreditsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof releaseCohortCredits>>,
  TError,
  { data: BodyType<ReleaseCohortCreditsBody> },
  TContext
> => {
  const mutationKey = ["releaseCohortCredits"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof releaseCohortCredits>>,
    { data: BodyType<ReleaseCohortCreditsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return releaseCohortCredits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReleaseCohortCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof releaseCohortCredits>>
>;
export type ReleaseCohortCreditsMutationBody =
  BodyType<ReleaseCohortCreditsBody>;
export type ReleaseCohortCreditsMutationError = ErrorType<void>;

export const useReleaseCohortCredits = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseCohortCredits>>,
    TError,
    { data: BodyType<ReleaseCohortCreditsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof releaseCohortCredits>>,
  TError,
  { data: BodyType<ReleaseCohortCreditsBody> },
  TContext
> => {
  return useMutation(getReleaseCohortCreditsMutationOptions(options));
};

/**
 * @summary Review identity conflicts before a research cohort import
 */
export const getPreviewCohortImportUrl = () => {
  return `/api/admin/investors/cohort-import/preview`;
};

export const previewCohortImport = async (
  cohortImportInput: CohortImportInput,
  options?: RequestInit,
): Promise<CohortImportReview> => {
  return customFetch<CohortImportReview>(getPreviewCohortImportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cohortImportInput),
  });
};

export const getPreviewCohortImportMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewCohortImport>>,
    TError,
    { data: BodyType<CohortImportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewCohortImport>>,
  TError,
  { data: BodyType<CohortImportInput> },
  TContext
> => {
  const mutationKey = ["previewCohortImport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewCohortImport>>,
    { data: BodyType<CohortImportInput> }
  > = (props) => {
    const { data } = props ?? {};

    return previewCohortImport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewCohortImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewCohortImport>>
>;
export type PreviewCohortImportMutationBody = BodyType<CohortImportInput>;
export type PreviewCohortImportMutationError = ErrorType<void>;

/**
 * @summary Review identity conflicts before a research cohort import
 */
export const usePreviewCohortImport = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewCohortImport>>,
    TError,
    { data: BodyType<CohortImportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewCohortImport>>,
  TError,
  { data: BodyType<CohortImportInput> },
  TContext
> => {
  return useMutation(getPreviewCohortImportMutationOptions(options));
};

/**
 * @summary Atomically import reviewed selected identities and cohort memberships only
 */
export const getCommitCohortImportUrl = () => {
  return `/api/admin/investors/cohort-import/commit`;
};

export const commitCohortImport = async (
  cohortImportConfirmation: CohortImportConfirmation,
  options?: RequestInit,
): Promise<CommitCohortImport200> => {
  return customFetch<CommitCohortImport200>(getCommitCohortImportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cohortImportConfirmation),
  });
};

export const getCommitCohortImportMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commitCohortImport>>,
    TError,
    { data: BodyType<CohortImportConfirmation> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof commitCohortImport>>,
  TError,
  { data: BodyType<CohortImportConfirmation> },
  TContext
> => {
  const mutationKey = ["commitCohortImport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof commitCohortImport>>,
    { data: BodyType<CohortImportConfirmation> }
  > = (props) => {
    const { data } = props ?? {};

    return commitCohortImport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommitCohortImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof commitCohortImport>>
>;
export type CommitCohortImportMutationBody = BodyType<CohortImportConfirmation>;
export type CommitCohortImportMutationError = ErrorType<void>;

/**
 * @summary Atomically import reviewed selected identities and cohort memberships only
 */
export const useCommitCohortImport = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commitCohortImport>>,
    TError,
    { data: BodyType<CohortImportConfirmation> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof commitCohortImport>>,
  TError,
  { data: BodyType<CohortImportConfirmation> },
  TContext
> => {
  return useMutation(getCommitCohortImportMutationOptions(options));
};

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all cohorts with this investor's membership status
 */
export const getListInvestorCohortMembershipsUrl = (investorId: number) => {
  return `/api/admin/investors/${investorId}/cohort-memberships`;
};

export const listInvestorCohortMemberships = async (
  investorId: number,
  options?: RequestInit,
): Promise<InvestorCohortMembershipList> => {
  return customFetch<InvestorCohortMembershipList>(
    getListInvestorCohortMembershipsUrl(investorId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInvestorCohortMembershipsQueryKey = (
  investorId: number,
) => {
  return [`/api/admin/investors/${investorId}/cohort-memberships`] as const;
};

export const getListInvestorCohortMembershipsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvestorCohortMemberships>>,
  TError = ErrorType<void>,
>(
  investorId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInvestorCohortMemberships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListInvestorCohortMembershipsQueryKey(investorId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInvestorCohortMemberships>>
  > = ({ signal }) =>
    listInvestorCohortMemberships(investorId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!investorId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvestorCohortMemberships>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvestorCohortMembershipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvestorCohortMemberships>>
>;
export type ListInvestorCohortMembershipsQueryError = ErrorType<void>;

/**
 * @summary List all cohorts with this investor's membership status
 */

export function useListInvestorCohortMemberships<
  TData = Awaited<ReturnType<typeof listInvestorCohortMemberships>>,
  TError = ErrorType<void>,
>(
  investorId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInvestorCohortMemberships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvestorCohortMembershipsQueryOptions(
    investorId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all cohorts
 */
export const getListCohortsUrl = () => {
  return `/api/cohorts`;
};

export const listCohorts = async (
  options?: RequestInit,
): Promise<CohortWithStats[]> => {
  return customFetch<CohortWithStats[]>(getListCohortsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCohortsQueryKey = () => {
  return [`/api/cohorts`] as const;
};

export const getListCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCohorts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCohorts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCohortsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCohorts>>> = ({
    signal,
  }) => listCohorts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCohorts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCohortsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCohorts>>
>;
export type ListCohortsQueryError = ErrorType<unknown>;

/**
 * @summary List all cohorts
 */

export function useListCohorts<
  TData = Awaited<ReturnType<typeof listCohorts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCohorts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCohortsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new cohort
 */
export const getCreateCohortUrl = () => {
  return `/api/cohorts`;
};

export const createCohort = async (
  createCohortBody: CreateCohortBody,
  options?: RequestInit,
): Promise<Cohort> => {
  return customFetch<Cohort>(getCreateCohortUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCohortBody),
  });
};

export const getCreateCohortMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCohort>>,
    TError,
    { data: BodyType<CreateCohortBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCohort>>,
  TError,
  { data: BodyType<CreateCohortBody> },
  TContext
> => {
  const mutationKey = ["createCohort"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCohort>>,
    { data: BodyType<CreateCohortBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCohort(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCohortMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCohort>>
>;
export type CreateCohortMutationBody = BodyType<CreateCohortBody>;
export type CreateCohortMutationError = ErrorType<unknown>;

/**
 * @summary Create a new cohort
 */
export const useCreateCohort = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCohort>>,
    TError,
    { data: BodyType<CreateCohortBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCohort>>,
  TError,
  { data: BodyType<CreateCohortBody> },
  TContext
> => {
  return useMutation(getCreateCohortMutationOptions(options));
};

/**
 * @summary Get cohort by slug
 */
export const getGetCohortBySlugUrl = (slug: string) => {
  return `/api/cohorts/${slug}`;
};

export const getCohortBySlug = async (
  slug: string,
  options?: RequestInit,
): Promise<CohortDetail> => {
  return customFetch<CohortDetail>(getGetCohortBySlugUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetCohortBySlugQueryKey = (slug: string) => {
  return [`/api/cohorts/${slug}`] as const;
};

export const getGetCohortBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortBySlug>>,
  TError = ErrorType<void>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCohortBySlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohortBySlug>>> = ({
    signal,
  }) => getCohortBySlug(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortBySlug>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCohortBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCohortBySlug>>
>;
export type GetCohortBySlugQueryError = ErrorType<void>;

/**
 * @summary Get cohort by slug
 */

export function useGetCohortBySlug<
  TData = Awaited<ReturnType<typeof getCohortBySlug>>,
  TError = ErrorType<void>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCohortBySlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCohortBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a cohort
 */
export const getUpdateCohortUrl = (slug: string) => {
  return `/api/cohorts/${slug}`;
};

export const updateCohort = async (
  slug: string,
  updateCohortBody: UpdateCohortBody,
  options?: RequestInit,
): Promise<Cohort> => {
  return customFetch<Cohort>(getUpdateCohortUrl(slug), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCohortBody),
  });
};

export const getUpdateCohortMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCohort>>,
    TError,
    { slug: string; data: BodyType<UpdateCohortBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCohort>>,
  TError,
  { slug: string; data: BodyType<UpdateCohortBody> },
  TContext
> => {
  const mutationKey = ["updateCohort"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCohort>>,
    { slug: string; data: BodyType<UpdateCohortBody> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return updateCohort(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCohortMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCohort>>
>;
export type UpdateCohortMutationBody = BodyType<UpdateCohortBody>;
export type UpdateCohortMutationError = ErrorType<unknown>;

/**
 * @summary Update a cohort
 */
export const useUpdateCohort = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCohort>>,
    TError,
    { slug: string; data: BodyType<UpdateCohortBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCohort>>,
  TError,
  { slug: string; data: BodyType<UpdateCohortBody> },
  TContext
> => {
  return useMutation(getUpdateCohortMutationOptions(options));
};

/**
 * @summary Get team members assigned to a cohort
 */
export const getGetCohortTeamUrl = (slug: string) => {
  return `/api/cohorts/${slug}/team`;
};

export const getCohortTeam = async (
  slug: string,
  options?: RequestInit,
): Promise<CohortTeamMemberEntry[]> => {
  return customFetch<CohortTeamMemberEntry[]>(getGetCohortTeamUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetCohortTeamQueryKey = (slug: string) => {
  return [`/api/cohorts/${slug}/team`] as const;
};

export const getGetCohortTeamQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortTeam>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCohortTeam>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortTeamQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohortTeam>>> = ({
    signal,
  }) => getCohortTeam(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortTeam>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCohortTeamQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCohortTeam>>
>;
export type GetCohortTeamQueryError = ErrorType<unknown>;

/**
 * @summary Get team members assigned to a cohort
 */

export function useGetCohortTeam<
  TData = Awaited<ReturnType<typeof getCohortTeam>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCohortTeam>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCohortTeamQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Assign a team member to a cohort
 */
export const getAssignTeamToCohortUrl = (slug: string) => {
  return `/api/cohorts/${slug}/team`;
};

export const assignTeamToCohort = async (
  slug: string,
  assignTeamBody: AssignTeamBody,
  options?: RequestInit,
): Promise<AssignTeamToCohort201> => {
  return customFetch<AssignTeamToCohort201>(getAssignTeamToCohortUrl(slug), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assignTeamBody),
  });
};

export const getAssignTeamToCohortMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignTeamToCohort>>,
    TError,
    { slug: string; data: BodyType<AssignTeamBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignTeamToCohort>>,
  TError,
  { slug: string; data: BodyType<AssignTeamBody> },
  TContext
> => {
  const mutationKey = ["assignTeamToCohort"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignTeamToCohort>>,
    { slug: string; data: BodyType<AssignTeamBody> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return assignTeamToCohort(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignTeamToCohortMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignTeamToCohort>>
>;
export type AssignTeamToCohortMutationBody = BodyType<AssignTeamBody>;
export type AssignTeamToCohortMutationError = ErrorType<unknown>;

/**
 * @summary Assign a team member to a cohort
 */
export const useAssignTeamToCohort = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignTeamToCohort>>,
    TError,
    { slug: string; data: BodyType<AssignTeamBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignTeamToCohort>>,
  TError,
  { slug: string; data: BodyType<AssignTeamBody> },
  TContext
> => {
  return useMutation(getAssignTeamToCohortMutationOptions(options));
};

/**
 * @summary Remove a team member from a cohort
 */
export const getRemoveTeamFromCohortUrl = (slug: string, memberId: number) => {
  return `/api/cohorts/${slug}/team/${memberId}`;
};

export const removeTeamFromCohort = async (
  slug: string,
  memberId: number,
  options?: RequestInit,
): Promise<RemoveTeamFromCohort200> => {
  return customFetch<RemoveTeamFromCohort200>(
    getRemoveTeamFromCohortUrl(slug, memberId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveTeamFromCohortMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTeamFromCohort>>,
    TError,
    { slug: string; memberId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeTeamFromCohort>>,
  TError,
  { slug: string; memberId: number },
  TContext
> => {
  const mutationKey = ["removeTeamFromCohort"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeTeamFromCohort>>,
    { slug: string; memberId: number }
  > = (props) => {
    const { slug, memberId } = props ?? {};

    return removeTeamFromCohort(slug, memberId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveTeamFromCohortMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeTeamFromCohort>>
>;

export type RemoveTeamFromCohortMutationError = ErrorType<unknown>;

/**
 * @summary Remove a team member from a cohort
 */
export const useRemoveTeamFromCohort = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTeamFromCohort>>,
    TError,
    { slug: string; memberId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeTeamFromCohort>>,
  TError,
  { slug: string; memberId: number },
  TContext
> => {
  return useMutation(getRemoveTeamFromCohortMutationOptions(options));
};

/**
 * @summary List all team members
 */
export const getListTeamMembersUrl = () => {
  return `/api/team-members`;
};

export const listTeamMembers = async (
  options?: RequestInit,
): Promise<TeamMember[]> => {
  return customFetch<TeamMember[]>(getListTeamMembersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTeamMembersQueryKey = () => {
  return [`/api/team-members`] as const;
};

export const getListTeamMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listTeamMembers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTeamMembers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTeamMembersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamMembers>>> = ({
    signal,
  }) => listTeamMembers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTeamMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTeamMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeamMembers>>
>;
export type ListTeamMembersQueryError = ErrorType<unknown>;

/**
 * @summary List all team members
 */

export function useListTeamMembers<
  TData = Awaited<ReturnType<typeof listTeamMembers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTeamMembers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTeamMembersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a team member
 */
export const getCreateTeamMemberUrl = () => {
  return `/api/team-members`;
};

export const createTeamMember = async (
  createTeamMemberBody: CreateTeamMemberBody,
  options?: RequestInit,
): Promise<TeamMember> => {
  return customFetch<TeamMember>(getCreateTeamMemberUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTeamMemberBody),
  });
};

export const getCreateTeamMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeamMember>>,
    TError,
    { data: BodyType<CreateTeamMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeamMember>>,
  TError,
  { data: BodyType<CreateTeamMemberBody> },
  TContext
> => {
  const mutationKey = ["createTeamMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeamMember>>,
    { data: BodyType<CreateTeamMemberBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTeamMember(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTeamMember>>
>;
export type CreateTeamMemberMutationBody = BodyType<CreateTeamMemberBody>;
export type CreateTeamMemberMutationError = ErrorType<unknown>;

/**
 * @summary Create a team member
 */
export const useCreateTeamMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeamMember>>,
    TError,
    { data: BodyType<CreateTeamMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTeamMember>>,
  TError,
  { data: BodyType<CreateTeamMemberBody> },
  TContext
> => {
  return useMutation(getCreateTeamMemberMutationOptions(options));
};

/**
 * @summary Update a team member
 */
export const getUpdateTeamMemberUrl = (id: number) => {
  return `/api/team-members/${id}`;
};

export const updateTeamMember = async (
  id: number,
  updateTeamMemberBody: UpdateTeamMemberBody,
  options?: RequestInit,
): Promise<TeamMember> => {
  return customFetch<TeamMember>(getUpdateTeamMemberUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTeamMemberBody),
  });
};

export const getUpdateTeamMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamMember>>,
    TError,
    { id: number; data: BodyType<UpdateTeamMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTeamMember>>,
  TError,
  { id: number; data: BodyType<UpdateTeamMemberBody> },
  TContext
> => {
  const mutationKey = ["updateTeamMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTeamMember>>,
    { id: number; data: BodyType<UpdateTeamMemberBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTeamMember(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTeamMember>>
>;
export type UpdateTeamMemberMutationBody = BodyType<UpdateTeamMemberBody>;
export type UpdateTeamMemberMutationError = ErrorType<unknown>;

/**
 * @summary Update a team member
 */
export const useUpdateTeamMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamMember>>,
    TError,
    { id: number; data: BodyType<UpdateTeamMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTeamMember>>,
  TError,
  { id: number; data: BodyType<UpdateTeamMemberBody> },
  TContext
> => {
  return useMutation(getUpdateTeamMemberMutationOptions(options));
};

/**
 * @summary List all portfolio companies
 */
export const getListCompaniesUrl = (params?: ListCompaniesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/companies?${stringifiedParams}`
    : `/api/companies`;
};

export const listCompanies = async (
  params?: ListCompaniesParams,
  options?: RequestInit,
): Promise<Company[]> => {
  return customFetch<Company[]>(getListCompaniesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCompaniesQueryKey = (params?: ListCompaniesParams) => {
  return [`/api/companies`, ...(params ? [params] : [])] as const;
};

export const getListCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCompanies>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCompaniesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCompanies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCompaniesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanies>>> = ({
    signal,
  }) => listCompanies(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCompanies>>
>;
export type ListCompaniesQueryError = ErrorType<unknown>;

/**
 * @summary List all portfolio companies
 */

export function useListCompanies<
  TData = Awaited<ReturnType<typeof listCompanies>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCompaniesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCompanies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCompaniesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new company
 */
export const getCreateCompanyUrl = () => {
  return `/api/companies`;
};

export const createCompany = async (
  createCompanyBody: CreateCompanyBody,
  options?: RequestInit,
): Promise<Company> => {
  return customFetch<Company>(getCreateCompanyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCompanyBody),
  });
};

export const getCreateCompanyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompany>>,
    TError,
    { data: BodyType<CreateCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCompany>>,
  TError,
  { data: BodyType<CreateCompanyBody> },
  TContext
> => {
  const mutationKey = ["createCompany"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCompany>>,
    { data: BodyType<CreateCompanyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCompany(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCompany>>
>;
export type CreateCompanyMutationBody = BodyType<CreateCompanyBody>;
export type CreateCompanyMutationError = ErrorType<unknown>;

/**
 * @summary Create a new company
 */
export const useCreateCompany = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompany>>,
    TError,
    { data: BodyType<CreateCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCompany>>,
  TError,
  { data: BodyType<CreateCompanyBody> },
  TContext
> => {
  return useMutation(getCreateCompanyMutationOptions(options));
};

/**
 * @summary Get company details
 */
export const getGetCompanyUrl = (id: number) => {
  return `/api/companies/${id}`;
};

export const getCompany = async (
  id: number,
  options?: RequestInit,
): Promise<Company> => {
  return customFetch<Company>(getGetCompanyUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCompanyQueryKey = (id: number) => {
  return [`/api/companies/${id}`] as const;
};

export const getGetCompanyQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompany>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCompany>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompanyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({
    signal,
  }) => getCompany(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompany>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompanyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompany>>
>;
export type GetCompanyQueryError = ErrorType<void>;

/**
 * @summary Get company details
 */

export function useGetCompany<
  TData = Awaited<ReturnType<typeof getCompany>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCompany>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCompanyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a company
 */
export const getUpdateCompanyUrl = (id: number) => {
  return `/api/companies/${id}`;
};

export const updateCompany = async (
  id: number,
  updateCompanyBody: UpdateCompanyBody,
  options?: RequestInit,
): Promise<Company> => {
  return customFetch<Company>(getUpdateCompanyUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCompanyBody),
  });
};

export const getUpdateCompanyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCompany>>,
    TError,
    { id: number; data: BodyType<UpdateCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCompany>>,
  TError,
  { id: number; data: BodyType<UpdateCompanyBody> },
  TContext
> => {
  const mutationKey = ["updateCompany"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCompany>>,
    { id: number; data: BodyType<UpdateCompanyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCompany(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCompany>>
>;
export type UpdateCompanyMutationBody = BodyType<UpdateCompanyBody>;
export type UpdateCompanyMutationError = ErrorType<unknown>;

/**
 * @summary Update a company
 */
export const useUpdateCompany = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCompany>>,
    TError,
    { id: number; data: BodyType<UpdateCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCompany>>,
  TError,
  { id: number; data: BodyType<UpdateCompanyBody> },
  TContext
> => {
  return useMutation(getUpdateCompanyMutationOptions(options));
};

/**
 * @summary Delete a company
 */
export const getDeleteCompanyUrl = (id: number) => {
  return `/api/companies/${id}`;
};

export const deleteCompany = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCompanyUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCompanyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCompany>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCompany>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCompany"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCompany>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCompany(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCompany>>
>;

export type DeleteCompanyMutationError = ErrorType<unknown>;

/**
 * @summary Delete a company
 */
export const useDeleteCompany = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCompany>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCompany>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCompanyMutationOptions(options));
};

/**
 * @summary List all founders
 */
export const getListFoundersUrl = (params?: ListFoundersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/founders?${stringifiedParams}`
    : `/api/founders`;
};

export const listFounders = async (
  params?: ListFoundersParams,
  options?: RequestInit,
): Promise<Founder[]> => {
  return customFetch<Founder[]>(getListFoundersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListFoundersQueryKey = (params?: ListFoundersParams) => {
  return [`/api/founders`, ...(params ? [params] : [])] as const;
};

export const getListFoundersQueryOptions = <
  TData = Awaited<ReturnType<typeof listFounders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFoundersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFounders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFoundersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFounders>>> = ({
    signal,
  }) => listFounders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFounders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFoundersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFounders>>
>;
export type ListFoundersQueryError = ErrorType<unknown>;

/**
 * @summary List all founders
 */

export function useListFounders<
  TData = Awaited<ReturnType<typeof listFounders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFoundersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFounders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFoundersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a founder
 */
export const getCreateFounderUrl = () => {
  return `/api/founders`;
};

export const createFounder = async (
  createFounderBody: CreateFounderBody,
  options?: RequestInit,
): Promise<Founder> => {
  return customFetch<Founder>(getCreateFounderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createFounderBody),
  });
};

export const getCreateFounderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFounder>>,
    TError,
    { data: BodyType<CreateFounderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFounder>>,
  TError,
  { data: BodyType<CreateFounderBody> },
  TContext
> => {
  const mutationKey = ["createFounder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFounder>>,
    { data: BodyType<CreateFounderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createFounder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFounderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFounder>>
>;
export type CreateFounderMutationBody = BodyType<CreateFounderBody>;
export type CreateFounderMutationError = ErrorType<unknown>;

/**
 * @summary Create a founder
 */
export const useCreateFounder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFounder>>,
    TError,
    { data: BodyType<CreateFounderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFounder>>,
  TError,
  { data: BodyType<CreateFounderBody> },
  TContext
> => {
  return useMutation(getCreateFounderMutationOptions(options));
};

/**
 * @summary Get founder details
 */
export const getGetFounderUrl = (id: number) => {
  return `/api/founders/${id}`;
};

export const getFounder = async (
  id: number,
  options?: RequestInit,
): Promise<Founder> => {
  return customFetch<Founder>(getGetFounderUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetFounderQueryKey = (id: number) => {
  return [`/api/founders/${id}`] as const;
};

export const getGetFounderQueryOptions = <
  TData = Awaited<ReturnType<typeof getFounder>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFounder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFounderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFounder>>> = ({
    signal,
  }) => getFounder(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFounder>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFounderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFounder>>
>;
export type GetFounderQueryError = ErrorType<unknown>;

/**
 * @summary Get founder details
 */

export function useGetFounder<
  TData = Awaited<ReturnType<typeof getFounder>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFounder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFounderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a founder
 */
export const getUpdateFounderUrl = (id: number) => {
  return `/api/founders/${id}`;
};

export const updateFounder = async (
  id: number,
  updateFounderBody: UpdateFounderBody,
  options?: RequestInit,
): Promise<Founder> => {
  return customFetch<Founder>(getUpdateFounderUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateFounderBody),
  });
};

export const getUpdateFounderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFounder>>,
    TError,
    { id: number; data: BodyType<UpdateFounderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFounder>>,
  TError,
  { id: number; data: BodyType<UpdateFounderBody> },
  TContext
> => {
  const mutationKey = ["updateFounder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFounder>>,
    { id: number; data: BodyType<UpdateFounderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFounder(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFounderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFounder>>
>;
export type UpdateFounderMutationBody = BodyType<UpdateFounderBody>;
export type UpdateFounderMutationError = ErrorType<unknown>;

/**
 * @summary Update a founder
 */
export const useUpdateFounder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFounder>>,
    TError,
    { id: number; data: BodyType<UpdateFounderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFounder>>,
  TError,
  { id: number; data: BodyType<UpdateFounderBody> },
  TContext
> => {
  return useMutation(getUpdateFounderMutationOptions(options));
};

/**
 * @summary List all investors
 */
export const getListInvestorsUrl = () => {
  return `/api/investors`;
};

export const listInvestors = async (
  options?: RequestInit,
): Promise<Investor[]> => {
  return customFetch<Investor[]>(getListInvestorsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListInvestorsQueryKey = () => {
  return [`/api/investors`] as const;
};

export const getListInvestorsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvestors>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInvestors>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvestorsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvestors>>> = ({
    signal,
  }) => listInvestors({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvestors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvestorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvestors>>
>;
export type ListInvestorsQueryError = ErrorType<unknown>;

/**
 * @summary List all investors
 */

export function useListInvestors<
  TData = Awaited<ReturnType<typeof listInvestors>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInvestors>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvestorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an investor
 */
export const getCreateInvestorUrl = () => {
  return `/api/investors`;
};

export const createInvestor = async (
  createInvestorBody: CreateInvestorBody,
  options?: RequestInit,
): Promise<Investor> => {
  return customFetch<Investor>(getCreateInvestorUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInvestorBody),
  });
};

export const getCreateInvestorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvestor>>,
    TError,
    { data: BodyType<CreateInvestorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvestor>>,
  TError,
  { data: BodyType<CreateInvestorBody> },
  TContext
> => {
  const mutationKey = ["createInvestor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvestor>>,
    { data: BodyType<CreateInvestorBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInvestor(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvestorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInvestor>>
>;
export type CreateInvestorMutationBody = BodyType<CreateInvestorBody>;
export type CreateInvestorMutationError = ErrorType<unknown>;

/**
 * @summary Create an investor
 */
export const useCreateInvestor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvestor>>,
    TError,
    { data: BodyType<CreateInvestorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInvestor>>,
  TError,
  { data: BodyType<CreateInvestorBody> },
  TContext
> => {
  return useMutation(getCreateInvestorMutationOptions(options));
};

/**
 * @summary Get investor details
 */
export const getGetInvestorUrl = (id: number) => {
  return `/api/investors/${id}`;
};

export const getInvestor = async (
  id: number,
  options?: RequestInit,
): Promise<Investor> => {
  return customFetch<Investor>(getGetInvestorUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInvestorQueryKey = (id: number) => {
  return [`/api/investors/${id}`] as const;
};

export const getGetInvestorQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvestor>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestor>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvestorQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvestor>>> = ({
    signal,
  }) => getInvestor(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvestor>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvestorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvestor>>
>;
export type GetInvestorQueryError = ErrorType<unknown>;

/**
 * @summary Get investor details
 */

export function useGetInvestor<
  TData = Awaited<ReturnType<typeof getInvestor>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestor>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvestorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an investor
 */
export const getUpdateInvestorUrl = (id: number) => {
  return `/api/investors/${id}`;
};

export const updateInvestor = async (
  id: number,
  updateInvestorBody: UpdateInvestorBody,
  options?: RequestInit,
): Promise<Investor> => {
  return customFetch<Investor>(getUpdateInvestorUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInvestorBody),
  });
};

export const getUpdateInvestorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInvestor>>,
    TError,
    { id: number; data: BodyType<UpdateInvestorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInvestor>>,
  TError,
  { id: number; data: BodyType<UpdateInvestorBody> },
  TContext
> => {
  const mutationKey = ["updateInvestor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInvestor>>,
    { id: number; data: BodyType<UpdateInvestorBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInvestor(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInvestorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInvestor>>
>;
export type UpdateInvestorMutationBody = BodyType<UpdateInvestorBody>;
export type UpdateInvestorMutationError = ErrorType<unknown>;

/**
 * @summary Update an investor
 */
export const useUpdateInvestor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInvestor>>,
    TError,
    { id: number; data: BodyType<UpdateInvestorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInvestor>>,
  TError,
  { id: number; data: BodyType<UpdateInvestorBody> },
  TContext
> => {
  return useMutation(getUpdateInvestorMutationOptions(options));
};

/**
 * Mints a fresh setup token and emails the investor the "Set your password" link. Idempotent: each call invalidates the previous token. Records the send time on the investor row so the UI can show "sent X ago".
 * @summary (Re)send the password-setup / onboarding email to an investor.
 */
export const getSendInvestorOnboardingEmailUrl = (id: number) => {
  return `/api/investors/${id}/send-onboarding-email`;
};

export const sendInvestorOnboardingEmail = async (
  id: number,
  options?: RequestInit,
): Promise<SendOnboardingEmailResponse> => {
  return customFetch<SendOnboardingEmailResponse>(
    getSendInvestorOnboardingEmailUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getSendInvestorOnboardingEmailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInvestorOnboardingEmail>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendInvestorOnboardingEmail>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendInvestorOnboardingEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendInvestorOnboardingEmail>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendInvestorOnboardingEmail(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendInvestorOnboardingEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendInvestorOnboardingEmail>>
>;

export type SendInvestorOnboardingEmailMutationError = ErrorType<void>;

/**
 * @summary (Re)send the password-setup / onboarding email to an investor.
 */
export const useSendInvestorOnboardingEmail = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInvestorOnboardingEmail>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendInvestorOnboardingEmail>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendInvestorOnboardingEmailMutationOptions(options));
};

/**
 * @summary List investor-company access permissions
 */
export const getListInvestorAccessUrl = (params?: ListInvestorAccessParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/investor-access?${stringifiedParams}`
    : `/api/investor-access`;
};

export const listInvestorAccess = async (
  params?: ListInvestorAccessParams,
  options?: RequestInit,
): Promise<InvestorAccess[]> => {
  return customFetch<InvestorAccess[]>(getListInvestorAccessUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInvestorAccessQueryKey = (
  params?: ListInvestorAccessParams,
) => {
  return [`/api/investor-access`, ...(params ? [params] : [])] as const;
};

export const getListInvestorAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvestorAccess>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInvestorAccessParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInvestorAccess>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInvestorAccessQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInvestorAccess>>
  > = ({ signal }) => listInvestorAccess(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvestorAccess>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvestorAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvestorAccess>>
>;
export type ListInvestorAccessQueryError = ErrorType<unknown>;

/**
 * @summary List investor-company access permissions
 */

export function useListInvestorAccess<
  TData = Awaited<ReturnType<typeof listInvestorAccess>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInvestorAccessParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInvestorAccess>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvestorAccessQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Grant investor access to a company
 */
export const getGrantInvestorAccessUrl = () => {
  return `/api/investor-access`;
};

export const grantInvestorAccess = async (
  grantInvestorAccessBody: GrantInvestorAccessBody,
  options?: RequestInit,
): Promise<InvestorAccess> => {
  return customFetch<InvestorAccess>(getGrantInvestorAccessUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(grantInvestorAccessBody),
  });
};

export const getGrantInvestorAccessMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantInvestorAccess>>,
    TError,
    { data: BodyType<GrantInvestorAccessBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantInvestorAccess>>,
  TError,
  { data: BodyType<GrantInvestorAccessBody> },
  TContext
> => {
  const mutationKey = ["grantInvestorAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantInvestorAccess>>,
    { data: BodyType<GrantInvestorAccessBody> }
  > = (props) => {
    const { data } = props ?? {};

    return grantInvestorAccess(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantInvestorAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantInvestorAccess>>
>;
export type GrantInvestorAccessMutationBody = BodyType<GrantInvestorAccessBody>;
export type GrantInvestorAccessMutationError = ErrorType<unknown>;

/**
 * @summary Grant investor access to a company
 */
export const useGrantInvestorAccess = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantInvestorAccess>>,
    TError,
    { data: BodyType<GrantInvestorAccessBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof grantInvestorAccess>>,
  TError,
  { data: BodyType<GrantInvestorAccessBody> },
  TContext
> => {
  return useMutation(getGrantInvestorAccessMutationOptions(options));
};

/**
 * @summary Revoke investor access
 */
export const getRevokeInvestorAccessUrl = (id: number) => {
  return `/api/investor-access/${id}`;
};

export const revokeInvestorAccess = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRevokeInvestorAccessUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRevokeInvestorAccessMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeInvestorAccess>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeInvestorAccess>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revokeInvestorAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeInvestorAccess>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revokeInvestorAccess(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeInvestorAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeInvestorAccess>>
>;

export type RevokeInvestorAccessMutationError = ErrorType<unknown>;

/**
 * @summary Revoke investor access
 */
export const useRevokeInvestorAccess = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeInvestorAccess>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeInvestorAccess>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRevokeInvestorAccessMutationOptions(options));
};

/**
 * @summary List documents
 */
export const getListDocumentsUrl = (params?: ListDocumentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/documents?${stringifiedParams}`
    : `/api/documents`;
};

export const listDocuments = async (
  params?: ListDocumentsParams,
  options?: RequestInit,
): Promise<Document[]> => {
  return customFetch<Document[]>(getListDocumentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListDocumentsQueryKey = (params?: ListDocumentsParams) => {
  return [`/api/documents`, ...(params ? [params] : [])] as const;
};

export const getListDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDocuments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDocumentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDocumentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocuments>>> = ({
    signal,
  }) => listDocuments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDocuments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDocuments>>
>;
export type ListDocumentsQueryError = ErrorType<unknown>;

/**
 * @summary List documents
 */

export function useListDocuments<
  TData = Awaited<ReturnType<typeof listDocuments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDocumentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDocumentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a document record
 */
export const getCreateDocumentUrl = () => {
  return `/api/documents`;
};

export const createDocument = async (
  createDocumentBody: CreateDocumentBody,
  options?: RequestInit,
): Promise<Document> => {
  return customFetch<Document>(getCreateDocumentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createDocumentBody),
  });
};

export const getCreateDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDocument>>,
    TError,
    { data: BodyType<CreateDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDocument>>,
  TError,
  { data: BodyType<CreateDocumentBody> },
  TContext
> => {
  const mutationKey = ["createDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDocument>>,
    { data: BodyType<CreateDocumentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createDocument(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDocument>>
>;
export type CreateDocumentMutationBody = BodyType<CreateDocumentBody>;
export type CreateDocumentMutationError = ErrorType<unknown>;

/**
 * @summary Create a document record
 */
export const useCreateDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDocument>>,
    TError,
    { data: BodyType<CreateDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDocument>>,
  TError,
  { data: BodyType<CreateDocumentBody> },
  TContext
> => {
  return useMutation(getCreateDocumentMutationOptions(options));
};

/**
 * @summary Delete a document
 */
export const getDeleteDocumentUrl = (id: number) => {
  return `/api/documents/${id}`;
};

export const deleteDocument = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteDocumentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDocument>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDocument>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDocument>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDocument(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDocument>>
>;

export type DeleteDocumentMutationError = ErrorType<unknown>;

/**
 * @summary Delete a document
 */
export const useDeleteDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDocument>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDocument>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteDocumentMutationOptions(options));
};

/**
 * @summary List weekly updates
 */
export const getListUpdatesUrl = (params?: ListUpdatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/updates?${stringifiedParams}`
    : `/api/updates`;
};

export const listUpdates = async (
  params?: ListUpdatesParams,
  options?: RequestInit,
): Promise<WeeklyUpdate[]> => {
  return customFetch<WeeklyUpdate[]>(getListUpdatesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListUpdatesQueryKey = (params?: ListUpdatesParams) => {
  return [`/api/updates`, ...(params ? [params] : [])] as const;
};

export const getListUpdatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listUpdates>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUpdatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUpdates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUpdatesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUpdates>>> = ({
    signal,
  }) => listUpdates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUpdates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUpdatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpdates>>
>;
export type ListUpdatesQueryError = ErrorType<unknown>;

/**
 * @summary List weekly updates
 */

export function useListUpdates<
  TData = Awaited<ReturnType<typeof listUpdates>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUpdatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUpdates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUpdatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a weekly update
 */
export const getCreateUpdateUrl = () => {
  return `/api/updates`;
};

export const createUpdate = async (
  createUpdateBody: CreateUpdateBody,
  options?: RequestInit,
): Promise<WeeklyUpdate> => {
  return customFetch<WeeklyUpdate>(getCreateUpdateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createUpdateBody),
  });
};

export const getCreateUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdate>>,
    TError,
    { data: BodyType<CreateUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUpdate>>,
  TError,
  { data: BodyType<CreateUpdateBody> },
  TContext
> => {
  const mutationKey = ["createUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUpdate>>,
    { data: BodyType<CreateUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpdate>>
>;
export type CreateUpdateMutationBody = BodyType<CreateUpdateBody>;
export type CreateUpdateMutationError = ErrorType<unknown>;

/**
 * @summary Create a weekly update
 */
export const useCreateUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdate>>,
    TError,
    { data: BodyType<CreateUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUpdate>>,
  TError,
  { data: BodyType<CreateUpdateBody> },
  TContext
> => {
  return useMutation(getCreateUpdateMutationOptions(options));
};

/**
 * @summary Get an update
 */
export const getGetUpdateUrl = (id: number) => {
  return `/api/updates/${id}`;
};

export const getUpdate = async (
  id: number,
  options?: RequestInit,
): Promise<WeeklyUpdate> => {
  return customFetch<WeeklyUpdate>(getGetUpdateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetUpdateQueryKey = (id: number) => {
  return [`/api/updates/${id}`] as const;
};

export const getGetUpdateQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpdate>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUpdate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUpdateQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdate>>> = ({
    signal,
  }) => getUpdate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUpdate>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetUpdateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpdate>>
>;
export type GetUpdateQueryError = ErrorType<unknown>;

/**
 * @summary Get an update
 */

export function useGetUpdate<
  TData = Awaited<ReturnType<typeof getUpdate>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUpdate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUpdateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Edit a weekly update
 */
export const getUpdateUpdateUrl = (id: number) => {
  return `/api/updates/${id}`;
};

export const updateUpdate = async (
  id: number,
  updateUpdateBody: UpdateUpdateBody,
  options?: RequestInit,
): Promise<WeeklyUpdate> => {
  return customFetch<WeeklyUpdate>(getUpdateUpdateUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUpdateBody),
  });
};

export const getUpdateUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUpdate>>,
    TError,
    { id: number; data: BodyType<UpdateUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUpdate>>,
  TError,
  { id: number; data: BodyType<UpdateUpdateBody> },
  TContext
> => {
  const mutationKey = ["updateUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUpdate>>,
    { id: number; data: BodyType<UpdateUpdateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpdate>>
>;
export type UpdateUpdateMutationBody = BodyType<UpdateUpdateBody>;
export type UpdateUpdateMutationError = ErrorType<unknown>;

/**
 * @summary Edit a weekly update
 */
export const useUpdateUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUpdate>>,
    TError,
    { id: number; data: BodyType<UpdateUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUpdate>>,
  TError,
  { id: number; data: BodyType<UpdateUpdateBody> },
  TContext
> => {
  return useMutation(getUpdateUpdateMutationOptions(options));
};

/**
 * @summary Approve a weekly update
 */
export const getApproveUpdateUrl = (id: number) => {
  return `/api/updates/${id}/approve`;
};

export const approveUpdate = async (
  id: number,
  options?: RequestInit,
): Promise<WeeklyUpdate> => {
  return customFetch<WeeklyUpdate>(getApproveUpdateUrl(id), {
    ...options,
    method: "PATCH",
  });
};

export const getApproveUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveUpdate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveUpdate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["approveUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveUpdate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return approveUpdate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveUpdate>>
>;

export type ApproveUpdateMutationError = ErrorType<unknown>;

/**
 * @summary Approve a weekly update
 */
export const useApproveUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveUpdate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveUpdate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getApproveUpdateMutationOptions(options));
};

/**
 * @summary List media assets
 */
export const getListMediaUrl = (params?: ListMediaParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/media?${stringifiedParams}`
    : `/api/media`;
};

export const listMedia = async (
  params?: ListMediaParams,
  options?: RequestInit,
): Promise<MediaAsset[]> => {
  return customFetch<MediaAsset[]>(getListMediaUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMediaQueryKey = (params?: ListMediaParams) => {
  return [`/api/media`, ...(params ? [params] : [])] as const;
};

export const getListMediaQueryOptions = <
  TData = Awaited<ReturnType<typeof listMedia>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMediaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMedia>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMediaQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMedia>>> = ({
    signal,
  }) => listMedia(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMedia>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMediaQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMedia>>
>;
export type ListMediaQueryError = ErrorType<unknown>;

/**
 * @summary List media assets
 */

export function useListMedia<
  TData = Awaited<ReturnType<typeof listMedia>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMediaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMedia>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMediaQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a media asset
 */
export const getCreateMediaUrl = () => {
  return `/api/media`;
};

export const createMedia = async (
  createMediaBody: CreateMediaBody,
  options?: RequestInit,
): Promise<MediaAsset> => {
  return customFetch<MediaAsset>(getCreateMediaUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMediaBody),
  });
};

export const getCreateMediaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMedia>>,
    TError,
    { data: BodyType<CreateMediaBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMedia>>,
  TError,
  { data: BodyType<CreateMediaBody> },
  TContext
> => {
  const mutationKey = ["createMedia"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMedia>>,
    { data: BodyType<CreateMediaBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMedia(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMediaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMedia>>
>;
export type CreateMediaMutationBody = BodyType<CreateMediaBody>;
export type CreateMediaMutationError = ErrorType<unknown>;

/**
 * @summary Create a media asset
 */
export const useCreateMedia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMedia>>,
    TError,
    { data: BodyType<CreateMediaBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMedia>>,
  TError,
  { data: BodyType<CreateMediaBody> },
  TContext
> => {
  return useMutation(getCreateMediaMutationOptions(options));
};

/**
 * @summary Delete a media asset
 */
export const getDeleteMediaUrl = (id: number) => {
  return `/api/media/${id}`;
};

export const deleteMedia = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMediaUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMediaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMedia>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMedia>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteMedia"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMedia>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMedia(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMediaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMedia>>
>;

export type DeleteMediaMutationError = ErrorType<unknown>;

/**
 * @summary Delete a media asset
 */
export const useDeleteMedia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMedia>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMedia>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteMediaMutationOptions(options));
};

/**
 * @summary List KPI entries
 */
export const getListKpisUrl = (params: ListKpisParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/kpis?${stringifiedParams}`
    : `/api/kpis`;
};

export const listKpis = async (
  params: ListKpisParams,
  options?: RequestInit,
): Promise<KpiEntry[]> => {
  return customFetch<KpiEntry[]>(getListKpisUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListKpisQueryKey = (params?: ListKpisParams) => {
  return [`/api/kpis`, ...(params ? [params] : [])] as const;
};

export const getListKpisQueryOptions = <
  TData = Awaited<ReturnType<typeof listKpis>>,
  TError = ErrorType<unknown>,
>(
  params: ListKpisParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listKpis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListKpisQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listKpis>>> = ({
    signal,
  }) => listKpis(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listKpis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListKpisQueryResult = NonNullable<
  Awaited<ReturnType<typeof listKpis>>
>;
export type ListKpisQueryError = ErrorType<unknown>;

/**
 * @summary List KPI entries
 */

export function useListKpis<
  TData = Awaited<ReturnType<typeof listKpis>>,
  TError = ErrorType<unknown>,
>(
  params: ListKpisParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listKpis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListKpisQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record a KPI entry
 */
export const getCreateKpiUrl = () => {
  return `/api/kpis`;
};

export const createKpi = async (
  createKpiBody: CreateKpiBody,
  options?: RequestInit,
): Promise<KpiEntry> => {
  return customFetch<KpiEntry>(getCreateKpiUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createKpiBody),
  });
};

export const getCreateKpiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKpi>>,
    TError,
    { data: BodyType<CreateKpiBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKpi>>,
  TError,
  { data: BodyType<CreateKpiBody> },
  TContext
> => {
  const mutationKey = ["createKpi"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKpi>>,
    { data: BodyType<CreateKpiBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createKpi(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKpiMutationResult = NonNullable<
  Awaited<ReturnType<typeof createKpi>>
>;
export type CreateKpiMutationBody = BodyType<CreateKpiBody>;
export type CreateKpiMutationError = ErrorType<unknown>;

/**
 * @summary Record a KPI entry
 */
export const useCreateKpi = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKpi>>,
    TError,
    { data: BodyType<CreateKpiBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createKpi>>,
  TError,
  { data: BodyType<CreateKpiBody> },
  TContext
> => {
  return useMutation(getCreateKpiMutationOptions(options));
};

/**
 * @summary List audit trail entries
 */
export const getListAuditLogUrl = (params?: ListAuditLogParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/audit-log?${stringifiedParams}`
    : `/api/audit-log`;
};

export const listAuditLog = async (
  params?: ListAuditLogParams,
  options?: RequestInit,
): Promise<AuditEntry[]> => {
  return customFetch<AuditEntry[]>(getListAuditLogUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAuditLogQueryKey = (params?: ListAuditLogParams) => {
  return [`/api/audit-log`, ...(params ? [params] : [])] as const;
};

export const getListAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuditLog>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAuditLogQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLog>>> = ({
    signal,
  }) => listAuditLog(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAuditLog>>
>;
export type ListAuditLogQueryError = ErrorType<unknown>;

/**
 * @summary List audit trail entries
 */

export function useListAuditLog<
  TData = Awaited<ReturnType<typeof listAuditLog>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Portfolio summary stats
 */
export const getGetDashboardSummaryUrl = (
  params?: GetDashboardSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/summary?${stringifiedParams}`
    : `/api/dashboard/summary`;
};

export const getDashboardSummary = async (
  params?: GetDashboardSummaryParams,
  options?: RequestInit,
): Promise<DashboardSummary> => {
  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = (
  params?: GetDashboardSummaryParams,
) => {
  return [`/api/dashboard/summary`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardSummary>>
  > = ({ signal }) =>
    getDashboardSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Portfolio summary stats
 */

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update health across portfolio
 */
export const getGetUpdateHealthUrl = (params?: GetUpdateHealthParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/update-health?${stringifiedParams}`
    : `/api/dashboard/update-health`;
};

export const getUpdateHealth = async (
  params?: GetUpdateHealthParams,
  options?: RequestInit,
): Promise<CompanyUpdateHealth[]> => {
  return customFetch<CompanyUpdateHealth[]>(getGetUpdateHealthUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetUpdateHealthQueryKey = (params?: GetUpdateHealthParams) => {
  return [`/api/dashboard/update-health`, ...(params ? [params] : [])] as const;
};

export const getGetUpdateHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpdateHealth>>,
  TError = ErrorType<unknown>,
>(
  params?: GetUpdateHealthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUpdateHealth>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUpdateHealthQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdateHealth>>> = ({
    signal,
  }) => getUpdateHealth(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpdateHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUpdateHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpdateHealth>>
>;
export type GetUpdateHealthQueryError = ErrorType<unknown>;

/**
 * @summary Update health across portfolio
 */

export function useGetUpdateHealth<
  TData = Awaited<ReturnType<typeof getUpdateHealth>>,
  TError = ErrorType<unknown>,
>(
  params?: GetUpdateHealthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUpdateHealth>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUpdateHealthQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Recent activity feed
 */
export const getGetRecentActivityUrl = (params?: GetRecentActivityParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/recent-activity?${stringifiedParams}`
    : `/api/dashboard/recent-activity`;
};

export const getRecentActivity = async (
  params?: GetRecentActivityParams,
  options?: RequestInit,
): Promise<ActivityItem[]> => {
  return customFetch<ActivityItem[]>(getGetRecentActivityUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRecentActivityQueryKey = (
  params?: GetRecentActivityParams,
) => {
  return [
    `/api/dashboard/recent-activity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentActivity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentActivityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentActivity>>
  > = ({ signal }) => getRecentActivity(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentActivity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentActivity>>
>;
export type GetRecentActivityQueryError = ErrorType<unknown>;

/**
 * @summary Recent activity feed
 */

export function useGetRecentActivity<
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentActivity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentActivityQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Pipeline stage breakdown
 */
export const getGetPipelineBreakdownUrl = (
  params?: GetPipelineBreakdownParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/pipeline?${stringifiedParams}`
    : `/api/dashboard/pipeline`;
};

export const getPipelineBreakdown = async (
  params?: GetPipelineBreakdownParams,
  options?: RequestInit,
): Promise<PipelineStage[]> => {
  return customFetch<PipelineStage[]>(getGetPipelineBreakdownUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPipelineBreakdownQueryKey = (
  params?: GetPipelineBreakdownParams,
) => {
  return [`/api/dashboard/pipeline`, ...(params ? [params] : [])] as const;
};

export const getGetPipelineBreakdownQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelineBreakdown>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPipelineBreakdownParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPipelineBreakdown>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPipelineBreakdownQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPipelineBreakdown>>
  > = ({ signal }) =>
    getPipelineBreakdown(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelineBreakdown>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelineBreakdownQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPipelineBreakdown>>
>;
export type GetPipelineBreakdownQueryError = ErrorType<unknown>;

/**
 * @summary Pipeline stage breakdown
 */

export function useGetPipelineBreakdown<
  TData = Awaited<ReturnType<typeof getPipelineBreakdown>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPipelineBreakdownParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPipelineBreakdown>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPipelineBreakdownQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List update cycles
 */
export const getListUpdateCyclesUrl = (params?: ListUpdateCyclesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/update-cycles?${stringifiedParams}`
    : `/api/update-cycles`;
};

export const listUpdateCycles = async (
  params?: ListUpdateCyclesParams,
  options?: RequestInit,
): Promise<UpdateCycle[]> => {
  return customFetch<UpdateCycle[]>(getListUpdateCyclesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListUpdateCyclesQueryKey = (
  params?: ListUpdateCyclesParams,
) => {
  return [`/api/update-cycles`, ...(params ? [params] : [])] as const;
};

export const getListUpdateCyclesQueryOptions = <
  TData = Awaited<ReturnType<typeof listUpdateCycles>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUpdateCyclesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUpdateCycles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListUpdateCyclesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUpdateCycles>>
  > = ({ signal }) => listUpdateCycles(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUpdateCycles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUpdateCyclesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpdateCycles>>
>;
export type ListUpdateCyclesQueryError = ErrorType<unknown>;

/**
 * @summary List update cycles
 */

export function useListUpdateCycles<
  TData = Awaited<ReturnType<typeof listUpdateCycles>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUpdateCyclesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUpdateCycles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUpdateCyclesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create update cycle
 */
export const getCreateUpdateCycleUrl = () => {
  return `/api/update-cycles`;
};

export const createUpdateCycle = async (
  createUpdateCycle: CreateUpdateCycle,
  options?: RequestInit,
): Promise<UpdateCycle> => {
  return customFetch<UpdateCycle>(getCreateUpdateCycleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createUpdateCycle),
  });
};

export const getCreateUpdateCycleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdateCycle>>,
    TError,
    { data: BodyType<CreateUpdateCycle> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUpdateCycle>>,
  TError,
  { data: BodyType<CreateUpdateCycle> },
  TContext
> => {
  const mutationKey = ["createUpdateCycle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUpdateCycle>>,
    { data: BodyType<CreateUpdateCycle> }
  > = (props) => {
    const { data } = props ?? {};

    return createUpdateCycle(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUpdateCycleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpdateCycle>>
>;
export type CreateUpdateCycleMutationBody = BodyType<CreateUpdateCycle>;
export type CreateUpdateCycleMutationError = ErrorType<unknown>;

/**
 * @summary Create update cycle
 */
export const useCreateUpdateCycle = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdateCycle>>,
    TError,
    { data: BodyType<CreateUpdateCycle> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUpdateCycle>>,
  TError,
  { data: BodyType<CreateUpdateCycle> },
  TContext
> => {
  return useMutation(getCreateUpdateCycleMutationOptions(options));
};

/**
 * @summary Transition update cycle state
 */
export const getTransitionUpdateCycleUrl = (id: number) => {
  return `/api/update-cycles/${id}/transition`;
};

export const transitionUpdateCycle = async (
  id: number,
  transitionUpdateCycleBody: TransitionUpdateCycleBody,
  options?: RequestInit,
): Promise<UpdateCycle> => {
  return customFetch<UpdateCycle>(getTransitionUpdateCycleUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(transitionUpdateCycleBody),
  });
};

export const getTransitionUpdateCycleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionUpdateCycle>>,
    TError,
    { id: number; data: BodyType<TransitionUpdateCycleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionUpdateCycle>>,
  TError,
  { id: number; data: BodyType<TransitionUpdateCycleBody> },
  TContext
> => {
  const mutationKey = ["transitionUpdateCycle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionUpdateCycle>>,
    { id: number; data: BodyType<TransitionUpdateCycleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return transitionUpdateCycle(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionUpdateCycleMutationResult = NonNullable<
  Awaited<ReturnType<typeof transitionUpdateCycle>>
>;
export type TransitionUpdateCycleMutationBody =
  BodyType<TransitionUpdateCycleBody>;
export type TransitionUpdateCycleMutationError = ErrorType<unknown>;

/**
 * @summary Transition update cycle state
 */
export const useTransitionUpdateCycle = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionUpdateCycle>>,
    TError,
    { id: number; data: BodyType<TransitionUpdateCycleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transitionUpdateCycle>>,
  TError,
  { id: number; data: BodyType<TransitionUpdateCycleBody> },
  TContext
> => {
  return useMutation(getTransitionUpdateCycleMutationOptions(options));
};

/**
 * @summary List update items
 */
export const getListUpdateItemsUrl = (params?: ListUpdateItemsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/update-items?${stringifiedParams}`
    : `/api/update-items`;
};

export const listUpdateItems = async (
  params?: ListUpdateItemsParams,
  options?: RequestInit,
): Promise<UpdateItem[]> => {
  return customFetch<UpdateItem[]>(getListUpdateItemsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListUpdateItemsQueryKey = (params?: ListUpdateItemsParams) => {
  return [`/api/update-items`, ...(params ? [params] : [])] as const;
};

export const getListUpdateItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUpdateItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUpdateItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUpdateItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUpdateItemsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUpdateItems>>> = ({
    signal,
  }) => listUpdateItems(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUpdateItems>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUpdateItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpdateItems>>
>;
export type ListUpdateItemsQueryError = ErrorType<unknown>;

/**
 * @summary List update items
 */

export function useListUpdateItems<
  TData = Awaited<ReturnType<typeof listUpdateItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUpdateItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUpdateItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUpdateItemsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create update item
 */
export const getCreateUpdateItemUrl = () => {
  return `/api/update-items`;
};

export const createUpdateItem = async (
  createUpdateItem: CreateUpdateItem,
  options?: RequestInit,
): Promise<UpdateItem> => {
  return customFetch<UpdateItem>(getCreateUpdateItemUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createUpdateItem),
  });
};

export const getCreateUpdateItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdateItem>>,
    TError,
    { data: BodyType<CreateUpdateItem> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUpdateItem>>,
  TError,
  { data: BodyType<CreateUpdateItem> },
  TContext
> => {
  const mutationKey = ["createUpdateItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUpdateItem>>,
    { data: BodyType<CreateUpdateItem> }
  > = (props) => {
    const { data } = props ?? {};

    return createUpdateItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUpdateItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpdateItem>>
>;
export type CreateUpdateItemMutationBody = BodyType<CreateUpdateItem>;
export type CreateUpdateItemMutationError = ErrorType<unknown>;

/**
 * @summary Create update item
 */
export const useCreateUpdateItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdateItem>>,
    TError,
    { data: BodyType<CreateUpdateItem> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUpdateItem>>,
  TError,
  { data: BodyType<CreateUpdateItem> },
  TContext
> => {
  return useMutation(getCreateUpdateItemMutationOptions(options));
};

/**
 * @summary Approve update item visibility
 */
export const getApproveUpdateItemUrl = (id: number) => {
  return `/api/update-items/${id}/approve`;
};

export const approveUpdateItem = async (
  id: number,
  approveUpdateItemBody: ApproveUpdateItemBody,
  options?: RequestInit,
): Promise<UpdateItem> => {
  return customFetch<UpdateItem>(getApproveUpdateItemUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(approveUpdateItemBody),
  });
};

export const getApproveUpdateItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveUpdateItem>>,
    TError,
    { id: number; data: BodyType<ApproveUpdateItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveUpdateItem>>,
  TError,
  { id: number; data: BodyType<ApproveUpdateItemBody> },
  TContext
> => {
  const mutationKey = ["approveUpdateItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveUpdateItem>>,
    { id: number; data: BodyType<ApproveUpdateItemBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return approveUpdateItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveUpdateItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveUpdateItem>>
>;
export type ApproveUpdateItemMutationBody = BodyType<ApproveUpdateItemBody>;
export type ApproveUpdateItemMutationError = ErrorType<unknown>;

/**
 * @summary Approve update item visibility
 */
export const useApproveUpdateItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveUpdateItem>>,
    TError,
    { id: number; data: BodyType<ApproveUpdateItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveUpdateItem>>,
  TError,
  { id: number; data: BodyType<ApproveUpdateItemBody> },
  TContext
> => {
  return useMutation(getApproveUpdateItemMutationOptions(options));
};

/**
 * @summary List source objects
 */
export const getListSourcesUrl = (params?: ListSourcesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/sources?${stringifiedParams}`
    : `/api/sources`;
};

export const listSources = async (
  params?: ListSourcesParams,
  options?: RequestInit,
): Promise<SourceObject[]> => {
  return customFetch<SourceObject[]>(getListSourcesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSourcesQueryKey = (params?: ListSourcesParams) => {
  return [`/api/sources`, ...(params ? [params] : [])] as const;
};

export const getListSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSources>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSourcesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSources>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSourcesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSources>>> = ({
    signal,
  }) => listSources(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSources>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSources>>
>;
export type ListSourcesQueryError = ErrorType<unknown>;

/**
 * @summary List source objects
 */

export function useListSources<
  TData = Awaited<ReturnType<typeof listSources>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSourcesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSources>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSourcesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create source object
 */
export const getCreateSourceUrl = () => {
  return `/api/sources`;
};

export const createSource = async (
  createSourceObject: CreateSourceObject,
  options?: RequestInit,
): Promise<SourceObject> => {
  return customFetch<SourceObject>(getCreateSourceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSourceObject),
  });
};

export const getCreateSourceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSource>>,
    TError,
    { data: BodyType<CreateSourceObject> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSource>>,
  TError,
  { data: BodyType<CreateSourceObject> },
  TContext
> => {
  const mutationKey = ["createSource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSource>>,
    { data: BodyType<CreateSourceObject> }
  > = (props) => {
    const { data } = props ?? {};

    return createSource(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSource>>
>;
export type CreateSourceMutationBody = BodyType<CreateSourceObject>;
export type CreateSourceMutationError = ErrorType<unknown>;

/**
 * @summary Create source object
 */
export const useCreateSource = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSource>>,
    TError,
    { data: BodyType<CreateSourceObject> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSource>>,
  TError,
  { data: BodyType<CreateSourceObject> },
  TContext
> => {
  return useMutation(getCreateSourceMutationOptions(options));
};

/**
 * @summary List equity relationships
 */
export const getListEquityRelationshipsUrl = (
  params?: ListEquityRelationshipsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/equity?${stringifiedParams}`
    : `/api/equity`;
};

export const listEquityRelationships = async (
  params?: ListEquityRelationshipsParams,
  options?: RequestInit,
): Promise<EquityRelationship[]> => {
  return customFetch<EquityRelationship[]>(
    getListEquityRelationshipsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListEquityRelationshipsQueryKey = (
  params?: ListEquityRelationshipsParams,
) => {
  return [`/api/equity`, ...(params ? [params] : [])] as const;
};

export const getListEquityRelationshipsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEquityRelationships>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEquityRelationshipsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEquityRelationships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEquityRelationshipsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEquityRelationships>>
  > = ({ signal }) =>
    listEquityRelationships(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEquityRelationships>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEquityRelationshipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEquityRelationships>>
>;
export type ListEquityRelationshipsQueryError = ErrorType<unknown>;

/**
 * @summary List equity relationships
 */

export function useListEquityRelationships<
  TData = Awaited<ReturnType<typeof listEquityRelationships>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEquityRelationshipsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEquityRelationships>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEquityRelationshipsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create equity relationship
 */
export const getCreateEquityRelationshipUrl = () => {
  return `/api/equity`;
};

export const createEquityRelationship = async (
  createEquityRelationship: CreateEquityRelationship,
  options?: RequestInit,
): Promise<EquityRelationship> => {
  return customFetch<EquityRelationship>(getCreateEquityRelationshipUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createEquityRelationship),
  });
};

export const getCreateEquityRelationshipMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEquityRelationship>>,
    TError,
    { data: BodyType<CreateEquityRelationship> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEquityRelationship>>,
  TError,
  { data: BodyType<CreateEquityRelationship> },
  TContext
> => {
  const mutationKey = ["createEquityRelationship"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEquityRelationship>>,
    { data: BodyType<CreateEquityRelationship> }
  > = (props) => {
    const { data } = props ?? {};

    return createEquityRelationship(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEquityRelationshipMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEquityRelationship>>
>;
export type CreateEquityRelationshipMutationBody =
  BodyType<CreateEquityRelationship>;
export type CreateEquityRelationshipMutationError = ErrorType<unknown>;

/**
 * @summary Create equity relationship
 */
export const useCreateEquityRelationship = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEquityRelationship>>,
    TError,
    { data: BodyType<CreateEquityRelationship> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEquityRelationship>>,
  TError,
  { data: BodyType<CreateEquityRelationship> },
  TContext
> => {
  return useMutation(getCreateEquityRelationshipMutationOptions(options));
};

/**
 * @summary List tasks and asks
 */
export const getListTasksUrl = (params?: ListTasksParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tasks?${stringifiedParams}`
    : `/api/tasks`;
};

export const listTasks = async (
  params?: ListTasksParams,
  options?: RequestInit,
): Promise<TaskAsk[]> => {
  return customFetch<TaskAsk[]>(getListTasksUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTasksQueryKey = (params?: ListTasksParams) => {
  return [`/api/tasks`, ...(params ? [params] : [])] as const;
};

export const getListTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({
    signal,
  }) => listTasks(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTasks>>
>;
export type ListTasksQueryError = ErrorType<unknown>;

/**
 * @summary List tasks and asks
 */

export function useListTasks<
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create task or ask
 */
export const getCreateTaskUrl = () => {
  return `/api/tasks`;
};

export const createTask = async (
  createTaskAsk: CreateTaskAsk,
  options?: RequestInit,
): Promise<TaskAsk> => {
  return customFetch<TaskAsk>(getCreateTaskUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaskAsk),
  });
};

export const getCreateTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<CreateTaskAsk> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<CreateTaskAsk> },
  TContext
> => {
  const mutationKey = ["createTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { data: BodyType<CreateTaskAsk> }
  > = (props) => {
    const { data } = props ?? {};

    return createTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTask>>
>;
export type CreateTaskMutationBody = BodyType<CreateTaskAsk>;
export type CreateTaskMutationError = ErrorType<unknown>;

/**
 * @summary Create task or ask
 */
export const useCreateTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<CreateTaskAsk> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<CreateTaskAsk> },
  TContext
> => {
  return useMutation(getCreateTaskMutationOptions(options));
};

/**
 * @summary Update task
 */
export const getUpdateTaskUrl = (id: number) => {
  return `/api/tasks/${id}`;
};

export const updateTask = async (
  id: number,
  updateTaskAsk: UpdateTaskAsk,
  options?: RequestInit,
): Promise<TaskAsk> => {
  return customFetch<TaskAsk>(getUpdateTaskUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaskAsk),
  });
};

export const getUpdateTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { id: number; data: BodyType<UpdateTaskAsk> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { id: number; data: BodyType<UpdateTaskAsk> },
  TContext
> => {
  const mutationKey = ["updateTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTask>>,
    { id: number; data: BodyType<UpdateTaskAsk> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTask>>
>;
export type UpdateTaskMutationBody = BodyType<UpdateTaskAsk>;
export type UpdateTaskMutationError = ErrorType<unknown>;

/**
 * @summary Update task
 */
export const useUpdateTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { id: number; data: BodyType<UpdateTaskAsk> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { id: number; data: BodyType<UpdateTaskAsk> },
  TContext
> => {
  return useMutation(getUpdateTaskMutationOptions(options));
};

/**
 * @summary Founder home screen data
 */
export const getGetFounderHomeUrl = (founderId: number) => {
  return `/api/founder/${founderId}/home`;
};

export const getFounderHome = async (
  founderId: number,
  options?: RequestInit,
): Promise<FounderHome> => {
  return customFetch<FounderHome>(getGetFounderHomeUrl(founderId), {
    ...options,
    method: "GET",
  });
};

export const getGetFounderHomeQueryKey = (founderId: number) => {
  return [`/api/founder/${founderId}/home`] as const;
};

export const getGetFounderHomeQueryOptions = <
  TData = Awaited<ReturnType<typeof getFounderHome>>,
  TError = ErrorType<unknown>,
>(
  founderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFounderHome>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFounderHomeQueryKey(founderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFounderHome>>> = ({
    signal,
  }) => getFounderHome(founderId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!founderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFounderHome>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFounderHomeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFounderHome>>
>;
export type GetFounderHomeQueryError = ErrorType<unknown>;

/**
 * @summary Founder home screen data
 */

export function useGetFounderHome<
  TData = Awaited<ReturnType<typeof getFounderHome>>,
  TError = ErrorType<unknown>,
>(
  founderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFounderHome>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFounderHomeQueryOptions(founderId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Submit weekly check-in
 */
export const getSubmitFounderCheckinUrl = (founderId: number) => {
  return `/api/founder/${founderId}/checkin`;
};

export const submitFounderCheckin = async (
  founderId: number,
  founderCheckin: FounderCheckin,
  options?: RequestInit,
): Promise<WeeklyUpdate> => {
  return customFetch<WeeklyUpdate>(getSubmitFounderCheckinUrl(founderId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(founderCheckin),
  });
};

export const getSubmitFounderCheckinMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitFounderCheckin>>,
    TError,
    { founderId: number; data: BodyType<FounderCheckin> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitFounderCheckin>>,
  TError,
  { founderId: number; data: BodyType<FounderCheckin> },
  TContext
> => {
  const mutationKey = ["submitFounderCheckin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitFounderCheckin>>,
    { founderId: number; data: BodyType<FounderCheckin> }
  > = (props) => {
    const { founderId, data } = props ?? {};

    return submitFounderCheckin(founderId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitFounderCheckinMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitFounderCheckin>>
>;
export type SubmitFounderCheckinMutationBody = BodyType<FounderCheckin>;
export type SubmitFounderCheckinMutationError = ErrorType<unknown>;

/**
 * @summary Submit weekly check-in
 */
export const useSubmitFounderCheckin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitFounderCheckin>>,
    TError,
    { founderId: number; data: BodyType<FounderCheckin> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitFounderCheckin>>,
  TError,
  { founderId: number; data: BodyType<FounderCheckin> },
  TContext
> => {
  return useMutation(getSubmitFounderCheckinMutationOptions(options));
};

/**
 * @summary Get items pending founder approval
 */
export const getGetFounderApprovalsUrl = (founderId: number) => {
  return `/api/founder/${founderId}/approvals`;
};

export const getFounderApprovals = async (
  founderId: number,
  options?: RequestInit,
): Promise<UpdateItem[]> => {
  return customFetch<UpdateItem[]>(getGetFounderApprovalsUrl(founderId), {
    ...options,
    method: "GET",
  });
};

export const getGetFounderApprovalsQueryKey = (founderId: number) => {
  return [`/api/founder/${founderId}/approvals`] as const;
};

export const getGetFounderApprovalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFounderApprovals>>,
  TError = ErrorType<unknown>,
>(
  founderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFounderApprovals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFounderApprovalsQueryKey(founderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFounderApprovals>>
  > = ({ signal }) =>
    getFounderApprovals(founderId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!founderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFounderApprovals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFounderApprovalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFounderApprovals>>
>;
export type GetFounderApprovalsQueryError = ErrorType<unknown>;

/**
 * @summary Get items pending founder approval
 */

export function useGetFounderApprovals<
  TData = Awaited<ReturnType<typeof getFounderApprovals>>,
  TError = ErrorType<unknown>,
>(
  founderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFounderApprovals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFounderApprovalsQueryOptions(founderId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Founder approves/rejects an item for external visibility
 */
export const getFounderApproveItemUrl = (founderId: number, itemId: number) => {
  return `/api/founder/${founderId}/approvals/${itemId}`;
};

export const founderApproveItem = async (
  founderId: number,
  itemId: number,
  founderApproveItemBody: FounderApproveItemBody,
  options?: RequestInit,
): Promise<UpdateItem> => {
  return customFetch<UpdateItem>(getFounderApproveItemUrl(founderId, itemId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(founderApproveItemBody),
  });
};

export const getFounderApproveItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof founderApproveItem>>,
    TError,
    {
      founderId: number;
      itemId: number;
      data: BodyType<FounderApproveItemBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof founderApproveItem>>,
  TError,
  { founderId: number; itemId: number; data: BodyType<FounderApproveItemBody> },
  TContext
> => {
  const mutationKey = ["founderApproveItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof founderApproveItem>>,
    {
      founderId: number;
      itemId: number;
      data: BodyType<FounderApproveItemBody>;
    }
  > = (props) => {
    const { founderId, itemId, data } = props ?? {};

    return founderApproveItem(founderId, itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FounderApproveItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof founderApproveItem>>
>;
export type FounderApproveItemMutationBody = BodyType<FounderApproveItemBody>;
export type FounderApproveItemMutationError = ErrorType<unknown>;

/**
 * @summary Founder approves/rejects an item for external visibility
 */
export const useFounderApproveItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof founderApproveItem>>,
    TError,
    {
      founderId: number;
      itemId: number;
      data: BodyType<FounderApproveItemBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof founderApproveItem>>,
  TError,
  { founderId: number; itemId: number; data: BodyType<FounderApproveItemBody> },
  TContext
> => {
  return useMutation(getFounderApproveItemMutationOptions(options));
};

/**
 * @summary Preview company profile as it appears to different audiences
 */
export const getGetFounderProfilePreviewUrl = (
  founderId: number,
  params: GetFounderProfilePreviewParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/founder/${founderId}/profile-preview?${stringifiedParams}`
    : `/api/founder/${founderId}/profile-preview`;
};

export const getFounderProfilePreview = async (
  founderId: number,
  params: GetFounderProfilePreviewParams,
  options?: RequestInit,
): Promise<CompanyMicrosite> => {
  return customFetch<CompanyMicrosite>(
    getGetFounderProfilePreviewUrl(founderId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetFounderProfilePreviewQueryKey = (
  founderId: number,
  params?: GetFounderProfilePreviewParams,
) => {
  return [
    `/api/founder/${founderId}/profile-preview`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFounderProfilePreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getFounderProfilePreview>>,
  TError = ErrorType<unknown>,
>(
  founderId: number,
  params: GetFounderProfilePreviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFounderProfilePreview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFounderProfilePreviewQueryKey(founderId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFounderProfilePreview>>
  > = ({ signal }) =>
    getFounderProfilePreview(founderId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!founderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFounderProfilePreview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFounderProfilePreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFounderProfilePreview>>
>;
export type GetFounderProfilePreviewQueryError = ErrorType<unknown>;

/**
 * @summary Preview company profile as it appears to different audiences
 */

export function useGetFounderProfilePreview<
  TData = Awaited<ReturnType<typeof getFounderProfilePreview>>,
  TError = ErrorType<unknown>,
>(
  founderId: number,
  params: GetFounderProfilePreviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFounderProfilePreview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFounderProfilePreviewQueryOptions(
    founderId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Investor home screen
 */
export const getGetInvestorHomeUrl = (investorId: number) => {
  return `/api/investor/${investorId}/home`;
};

export const getInvestorHome = async (
  investorId: number,
  options?: RequestInit,
): Promise<InvestorHome> => {
  return customFetch<InvestorHome>(getGetInvestorHomeUrl(investorId), {
    ...options,
    method: "GET",
  });
};

export const getGetInvestorHomeQueryKey = (investorId: number) => {
  return [`/api/investor/${investorId}/home`] as const;
};

export const getGetInvestorHomeQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvestorHome>>,
  TError = ErrorType<unknown>,
>(
  investorId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestorHome>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvestorHomeQueryKey(investorId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvestorHome>>> = ({
    signal,
  }) => getInvestorHome(investorId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!investorId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvestorHome>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvestorHomeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvestorHome>>
>;
export type GetInvestorHomeQueryError = ErrorType<unknown>;

/**
 * @summary Investor home screen
 */

export function useGetInvestorHome<
  TData = Awaited<ReturnType<typeof getInvestorHome>>,
  TError = ErrorType<unknown>,
>(
  investorId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestorHome>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvestorHomeQueryOptions(investorId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Company microsite for investor
 */
export const getGetInvestorCompanyMicrositeUrl = (
  investorId: number,
  companyId: number,
) => {
  return `/api/investor/${investorId}/companies/${companyId}`;
};

export const getInvestorCompanyMicrosite = async (
  investorId: number,
  companyId: number,
  options?: RequestInit,
): Promise<CompanyMicrosite> => {
  return customFetch<CompanyMicrosite>(
    getGetInvestorCompanyMicrositeUrl(investorId, companyId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInvestorCompanyMicrositeQueryKey = (
  investorId: number,
  companyId: number,
) => {
  return [`/api/investor/${investorId}/companies/${companyId}`] as const;
};

export const getGetInvestorCompanyMicrositeQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvestorCompanyMicrosite>>,
  TError = ErrorType<void>,
>(
  investorId: number,
  companyId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestorCompanyMicrosite>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInvestorCompanyMicrositeQueryKey(investorId, companyId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInvestorCompanyMicrosite>>
  > = ({ signal }) =>
    getInvestorCompanyMicrosite(investorId, companyId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(investorId && companyId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvestorCompanyMicrosite>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvestorCompanyMicrositeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvestorCompanyMicrosite>>
>;
export type GetInvestorCompanyMicrositeQueryError = ErrorType<void>;

/**
 * @summary Company microsite for investor
 */

export function useGetInvestorCompanyMicrosite<
  TData = Awaited<ReturnType<typeof getInvestorCompanyMicrosite>>,
  TError = ErrorType<void>,
>(
  investorId: number,
  companyId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestorCompanyMicrosite>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvestorCompanyMicrositeQueryOptions(
    investorId,
    companyId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Approved update timeline for investor
 */
export const getGetInvestorCompanyUpdatesUrl = (
  investorId: number,
  companyId: number,
) => {
  return `/api/investor/${investorId}/companies/${companyId}/updates`;
};

export const getInvestorCompanyUpdates = async (
  investorId: number,
  companyId: number,
  options?: RequestInit,
): Promise<UpdateCycleWithItems[]> => {
  return customFetch<UpdateCycleWithItems[]>(
    getGetInvestorCompanyUpdatesUrl(investorId, companyId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInvestorCompanyUpdatesQueryKey = (
  investorId: number,
  companyId: number,
) => {
  return [
    `/api/investor/${investorId}/companies/${companyId}/updates`,
  ] as const;
};

export const getGetInvestorCompanyUpdatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvestorCompanyUpdates>>,
  TError = ErrorType<unknown>,
>(
  investorId: number,
  companyId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestorCompanyUpdates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInvestorCompanyUpdatesQueryKey(investorId, companyId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInvestorCompanyUpdates>>
  > = ({ signal }) =>
    getInvestorCompanyUpdates(investorId, companyId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(investorId && companyId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvestorCompanyUpdates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvestorCompanyUpdatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvestorCompanyUpdates>>
>;
export type GetInvestorCompanyUpdatesQueryError = ErrorType<unknown>;

/**
 * @summary Approved update timeline for investor
 */

export function useGetInvestorCompanyUpdates<
  TData = Awaited<ReturnType<typeof getInvestorCompanyUpdates>>,
  TError = ErrorType<unknown>,
>(
  investorId: number,
  companyId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvestorCompanyUpdates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvestorCompanyUpdatesQueryOptions(
    investorId,
    companyId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Roll-up of every investor who has chatted, sorted by most-recent activity
 */
export const getListAdminConversationsUrl = () => {
  return `/api/admin/conversations`;
};

export const listAdminConversations = async (
  options?: RequestInit,
): Promise<AdminConversationsRollupRow[]> => {
  return customFetch<AdminConversationsRollupRow[]>(
    getListAdminConversationsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminConversationsQueryKey = () => {
  return [`/api/admin/conversations`] as const;
};

export const getListAdminConversationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminConversations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminConversations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminConversationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminConversations>>
  > = ({ signal }) => listAdminConversations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminConversations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminConversationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminConversations>>
>;
export type ListAdminConversationsQueryError = ErrorType<unknown>;

/**
 * @summary Roll-up of every investor who has chatted, sorted by most-recent activity
 */

export function useListAdminConversations<
  TData = Awaited<ReturnType<typeof listAdminConversations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminConversations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminConversationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Full drill-down for one investor — sessions list + transcript for one date
 */
export const getGetAdminConversationDrillDownUrl = (
  investorId: number,
  params?: GetAdminConversationDrillDownParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/conversations/${investorId}?${stringifiedParams}`
    : `/api/admin/conversations/${investorId}`;
};

export const getAdminConversationDrillDown = async (
  investorId: number,
  params?: GetAdminConversationDrillDownParams,
  options?: RequestInit,
): Promise<AdminConversationDrillDownResponse> => {
  return customFetch<AdminConversationDrillDownResponse>(
    getGetAdminConversationDrillDownUrl(investorId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminConversationDrillDownQueryKey = (
  investorId: number,
  params?: GetAdminConversationDrillDownParams,
) => {
  return [
    `/api/admin/conversations/${investorId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminConversationDrillDownQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminConversationDrillDown>>,
  TError = ErrorType<void>,
>(
  investorId: number,
  params?: GetAdminConversationDrillDownParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminConversationDrillDown>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminConversationDrillDownQueryKey(investorId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminConversationDrillDown>>
  > = ({ signal }) =>
    getAdminConversationDrillDown(investorId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!investorId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminConversationDrillDown>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminConversationDrillDownQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminConversationDrillDown>>
>;
export type GetAdminConversationDrillDownQueryError = ErrorType<void>;

/**
 * @summary Full drill-down for one investor — sessions list + transcript for one date
 */

export function useGetAdminConversationDrillDown<
  TData = Awaited<ReturnType<typeof getAdminConversationDrillDown>>,
  TError = ErrorType<void>,
>(
  investorId: number,
  params?: GetAdminConversationDrillDownParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminConversationDrillDown>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminConversationDrillDownQueryOptions(
    investorId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Rollup of every founder/company this advisor covers, with activation + SLA state
 */
export const getGetMyFoundersUrl = (params?: GetMyFoundersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/banker/my-founders?${stringifiedParams}`
    : `/api/banker/my-founders`;
};

export const getMyFounders = async (
  params?: GetMyFoundersParams,
  options?: RequestInit,
): Promise<MyFoundersResponse> => {
  return customFetch<MyFoundersResponse>(getGetMyFoundersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMyFoundersQueryKey = (params?: GetMyFoundersParams) => {
  return [`/api/banker/my-founders`, ...(params ? [params] : [])] as const;
};

export const getGetMyFoundersQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyFounders>>,
  TError = ErrorType<void>,
>(
  params?: GetMyFoundersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyFounders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyFoundersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyFounders>>> = ({
    signal,
  }) => getMyFounders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyFounders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyFoundersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyFounders>>
>;
export type GetMyFoundersQueryError = ErrorType<void>;

/**
 * @summary Rollup of every founder/company this advisor covers, with activation + SLA state
 */

export function useGetMyFounders<
  TData = Awaited<ReturnType<typeof getMyFounders>>,
  TError = ErrorType<void>,
>(
  params?: GetMyFoundersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyFounders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyFoundersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List announcements for a cohort
 */
export const getListCohortAnnouncementsUrl = (slug: string) => {
  return `/api/admin/cohorts/${slug}/announcements`;
};

export const listCohortAnnouncements = async (
  slug: string,
  options?: RequestInit,
): Promise<CohortAnnouncement[]> => {
  return customFetch<CohortAnnouncement[]>(
    getListCohortAnnouncementsUrl(slug),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCohortAnnouncementsQueryKey = (slug: string) => {
  return [`/api/admin/cohorts/${slug}/announcements`] as const;
};

export const getListCohortAnnouncementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCohortAnnouncements>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCohortAnnouncements>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCohortAnnouncementsQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCohortAnnouncements>>
  > = ({ signal }) =>
    listCohortAnnouncements(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCohortAnnouncements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCohortAnnouncementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCohortAnnouncements>>
>;
export type ListCohortAnnouncementsQueryError = ErrorType<unknown>;

/**
 * @summary List announcements for a cohort
 */

export function useListCohortAnnouncements<
  TData = Awaited<ReturnType<typeof listCohortAnnouncements>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCohortAnnouncements>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCohortAnnouncementsQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a draft announcement for a cohort
 */
export const getCreateCohortAnnouncementUrl = (slug: string) => {
  return `/api/admin/cohorts/${slug}/announcements`;
};

export const createCohortAnnouncement = async (
  slug: string,
  createAnnouncementBody: CreateAnnouncementBody,
  options?: RequestInit,
): Promise<CohortAnnouncement> => {
  return customFetch<CohortAnnouncement>(getCreateCohortAnnouncementUrl(slug), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAnnouncementBody),
  });
};

export const getCreateCohortAnnouncementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCohortAnnouncement>>,
    TError,
    { slug: string; data: BodyType<CreateAnnouncementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCohortAnnouncement>>,
  TError,
  { slug: string; data: BodyType<CreateAnnouncementBody> },
  TContext
> => {
  const mutationKey = ["createCohortAnnouncement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCohortAnnouncement>>,
    { slug: string; data: BodyType<CreateAnnouncementBody> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return createCohortAnnouncement(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCohortAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCohortAnnouncement>>
>;
export type CreateCohortAnnouncementMutationBody =
  BodyType<CreateAnnouncementBody>;
export type CreateCohortAnnouncementMutationError = ErrorType<unknown>;

/**
 * @summary Create a draft announcement for a cohort
 */
export const useCreateCohortAnnouncement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCohortAnnouncement>>,
    TError,
    { slug: string; data: BodyType<CreateAnnouncementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCohortAnnouncement>>,
  TError,
  { slug: string; data: BodyType<CreateAnnouncementBody> },
  TContext
> => {
  return useMutation(getCreateCohortAnnouncementMutationOptions(options));
};

/**
 * @summary Preview active investors who would receive an announcement
 */
export const getGetAnnouncementRecipientsUrl = (slug: string) => {
  return `/api/admin/cohorts/${slug}/announcement-recipients`;
};

export const getAnnouncementRecipients = async (
  slug: string,
  options?: RequestInit,
): Promise<AnnouncementRecipientsResponse> => {
  return customFetch<AnnouncementRecipientsResponse>(
    getGetAnnouncementRecipientsUrl(slug),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAnnouncementRecipientsQueryKey = (slug: string) => {
  return [`/api/admin/cohorts/${slug}/announcement-recipients`] as const;
};

export const getGetAnnouncementRecipientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnnouncementRecipients>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnnouncementRecipients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnnouncementRecipientsQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnnouncementRecipients>>
  > = ({ signal }) =>
    getAnnouncementRecipients(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnnouncementRecipients>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnnouncementRecipientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnnouncementRecipients>>
>;
export type GetAnnouncementRecipientsQueryError = ErrorType<unknown>;

/**
 * @summary Preview active investors who would receive an announcement
 */

export function useGetAnnouncementRecipients<
  TData = Awaited<ReturnType<typeof getAnnouncementRecipients>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnnouncementRecipients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnnouncementRecipientsQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send an announcement to all active cohort investors (idempotent)
 */
export const getSendCohortAnnouncementUrl = (id: number) => {
  return `/api/admin/announcements/${id}/send`;
};

export const sendCohortAnnouncement = async (
  id: number,
  options?: RequestInit,
): Promise<AnnouncementSendResult> => {
  return customFetch<AnnouncementSendResult>(getSendCohortAnnouncementUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSendCohortAnnouncementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendCohortAnnouncement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendCohortAnnouncement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendCohortAnnouncement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendCohortAnnouncement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendCohortAnnouncement(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendCohortAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendCohortAnnouncement>>
>;

export type SendCohortAnnouncementMutationError = ErrorType<unknown>;

/**
 * @summary Send an announcement to all active cohort investors (idempotent)
 */
export const useSendCohortAnnouncement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendCohortAnnouncement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendCohortAnnouncement>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendCohortAnnouncementMutationOptions(options));
};

/**
 * @summary Get one announcement with per-recipient delivery detail
 */
export const getGetCohortAnnouncementUrl = (id: number) => {
  return `/api/admin/announcements/${id}`;
};

export const getCohortAnnouncement = async (
  id: number,
  options?: RequestInit,
): Promise<CohortAnnouncementDetail> => {
  return customFetch<CohortAnnouncementDetail>(
    getGetCohortAnnouncementUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCohortAnnouncementQueryKey = (id: number) => {
  return [`/api/admin/announcements/${id}`] as const;
};

export const getGetCohortAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortAnnouncement>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCohortAnnouncement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCohortAnnouncementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCohortAnnouncement>>
  > = ({ signal }) => getCohortAnnouncement(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCohortAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCohortAnnouncement>>
>;
export type GetCohortAnnouncementQueryError = ErrorType<void>;

/**
 * @summary Get one announcement with per-recipient delivery detail
 */

export function useGetCohortAnnouncement<
  TData = Awaited<ReturnType<typeof getCohortAnnouncement>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCohortAnnouncement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCohortAnnouncementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List Kavya briefing notes for a cohort
 */
export const getListKavyaBriefingNotesUrl = (slug: string) => {
  return `/api/admin/cohorts/${slug}/kavya-notes`;
};

export const listKavyaBriefingNotes = async (
  slug: string,
  options?: RequestInit,
): Promise<KavyaBriefingNote[]> => {
  return customFetch<KavyaBriefingNote[]>(getListKavyaBriefingNotesUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getListKavyaBriefingNotesQueryKey = (slug: string) => {
  return [`/api/admin/cohorts/${slug}/kavya-notes`] as const;
};

export const getListKavyaBriefingNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listKavyaBriefingNotes>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listKavyaBriefingNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListKavyaBriefingNotesQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listKavyaBriefingNotes>>
  > = ({ signal }) =>
    listKavyaBriefingNotes(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listKavyaBriefingNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListKavyaBriefingNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listKavyaBriefingNotes>>
>;
export type ListKavyaBriefingNotesQueryError = ErrorType<unknown>;

/**
 * @summary List Kavya briefing notes for a cohort
 */

export function useListKavyaBriefingNotes<
  TData = Awaited<ReturnType<typeof listKavyaBriefingNotes>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listKavyaBriefingNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListKavyaBriefingNotesQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a Kavya briefing note for a cohort
 */
export const getCreateKavyaBriefingNoteUrl = (slug: string) => {
  return `/api/admin/cohorts/${slug}/kavya-notes`;
};

export const createKavyaBriefingNote = async (
  slug: string,
  createKavyaNoteBody: CreateKavyaNoteBody,
  options?: RequestInit,
): Promise<KavyaBriefingNote> => {
  return customFetch<KavyaBriefingNote>(getCreateKavyaBriefingNoteUrl(slug), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createKavyaNoteBody),
  });
};

export const getCreateKavyaBriefingNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKavyaBriefingNote>>,
    TError,
    { slug: string; data: BodyType<CreateKavyaNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKavyaBriefingNote>>,
  TError,
  { slug: string; data: BodyType<CreateKavyaNoteBody> },
  TContext
> => {
  const mutationKey = ["createKavyaBriefingNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKavyaBriefingNote>>,
    { slug: string; data: BodyType<CreateKavyaNoteBody> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return createKavyaBriefingNote(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKavyaBriefingNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createKavyaBriefingNote>>
>;
export type CreateKavyaBriefingNoteMutationBody = BodyType<CreateKavyaNoteBody>;
export type CreateKavyaBriefingNoteMutationError = ErrorType<unknown>;

/**
 * @summary Create a Kavya briefing note for a cohort
 */
export const useCreateKavyaBriefingNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKavyaBriefingNote>>,
    TError,
    { slug: string; data: BodyType<CreateKavyaNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createKavyaBriefingNote>>,
  TError,
  { slug: string; data: BodyType<CreateKavyaNoteBody> },
  TContext
> => {
  return useMutation(getCreateKavyaBriefingNoteMutationOptions(options));
};

/**
 * @summary Update or archive a Kavya briefing note
 */
export const getUpdateKavyaBriefingNoteUrl = (id: number) => {
  return `/api/admin/kavya-notes/${id}`;
};

export const updateKavyaBriefingNote = async (
  id: number,
  updateKavyaNoteBody: UpdateKavyaNoteBody,
  options?: RequestInit,
): Promise<KavyaBriefingNote> => {
  return customFetch<KavyaBriefingNote>(getUpdateKavyaBriefingNoteUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateKavyaNoteBody),
  });
};

export const getUpdateKavyaBriefingNoteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateKavyaBriefingNote>>,
    TError,
    { id: number; data: BodyType<UpdateKavyaNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateKavyaBriefingNote>>,
  TError,
  { id: number; data: BodyType<UpdateKavyaNoteBody> },
  TContext
> => {
  const mutationKey = ["updateKavyaBriefingNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateKavyaBriefingNote>>,
    { id: number; data: BodyType<UpdateKavyaNoteBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateKavyaBriefingNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateKavyaBriefingNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateKavyaBriefingNote>>
>;
export type UpdateKavyaBriefingNoteMutationBody = BodyType<UpdateKavyaNoteBody>;
export type UpdateKavyaBriefingNoteMutationError = ErrorType<void>;

/**
 * @summary Update or archive a Kavya briefing note
 */
export const useUpdateKavyaBriefingNote = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateKavyaBriefingNote>>,
    TError,
    { id: number; data: BodyType<UpdateKavyaNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateKavyaBriefingNote>>,
  TError,
  { id: number; data: BodyType<UpdateKavyaNoteBody> },
  TContext
> => {
  return useMutation(getUpdateKavyaBriefingNoteMutationOptions(options));
};
